{
  "about.blocks": "Moderált kiszolgálók",
  "about.contact": "Kapcsolat:",
  "about.default_locale": "Alapértelmezett",
  "about.disclaimer": "A Mastodon ingyenes, nyílt forráskódú szoftver, a Mastodon gGmbH védjegye.",
  "about.domain_blocks.no_reason_available": "Nem áll rendelkezésre indoklás",
  "about.domain_blocks.preamble": "A Mastodon általában mindenféle tartalomcserét és interakciót lehetővé tesz bármelyik másik kiszolgálóval a födiverzumban. Ezek azok a kivételek, amelyek a mi kiszolgálónkon érvényben vannak.",
  "about.domain_blocks.silenced.explanation": "Általában nem fogsz profilokat és tartalmat látni erről a kiszolgálóról, hacsak közvetlenül fel nem keresed vagy követed.",
  "about.domain_blocks.silenced.title": "Korlátozott",
  "about.domain_blocks.suspended.explanation": "A kiszolgáló adatai nem lesznek feldolgozva, tárolva vagy megosztva, lehetetlenné téve mindennemű interakciót és kommunikációt a kiszolgáló felhasználóival.",
  "about.domain_blocks.suspended.title": "Felfüggesztett",
  "about.language_label": "Nyelv",
  "about.not_available": "Ez az információ nem lett közzétéve ezen a kiszolgálón.",
  "about.powered_by": "Decentralizált közösségi média a {mastodon} segítségével",
  "about.rules": "Kiszolgáló szabályai",
  "account.account_note_header": "Személyes megjegyzés",
  "account.activity": "Tevékenység",
  "account.add_note": "Személyes megjegyzés hozzáadása",
  "account.add_or_remove_from_list": "Hozzáadás vagy eltávolítás a listákról",
  "account.badges.admin": "Adminisztrátor",
  "account.badges.blocked": "Letiltva",
  "account.badges.bot": "Automatizált",
  "account.badges.domain_blocked": "Letiltott domain",
  "account.badges.group": "Csoport",
  "account.badges.muted": "Némítva",
  "account.badges.muted_until": "Némítva eddig: {until}",
  "account.block": "@{name} letiltása",
  "account.block_domain": "Domain letiltása: {domain}",
  "account.block_short": "Letiltás",
  "account.blocked": "Letiltva",
  "account.cancel_follow_request": "Követési kérés visszavonása",
  "account.copy": "Hivatkozás másolása a profilba",
  "account.direct": "@{name} személyes említése",
  "account.disable_notifications": "Ne figyelmeztessen, ha @{name} bejegyzést tesz közzé",
  "account.edit_note": "Személyes megjegyzés szerkesztése",
  "account.edit_profile": "Profil szerkesztése",
  "account.edit_profile_short": "Szerkesztés",
  "account.enable_notifications": "Figyelmeztessen, ha @{name} bejegyzést tesz közzé",
  "account.endorse": "Kiemelés a profilodon",
  "account.familiar_followers_many": "{name1}, {name2} és még {othersCount, plural, one {egy valaki} other {# valaki}}, akit ismersz",
  "account.familiar_followers_one": "{name1} követi",
  "account.familiar_followers_two": "{name1} és {name2} követi",
  "account.featured": "Kiemelt",
  "account.featured.accounts": "Profilok",
  "account.featured.collections": "Gyűjtemények",
  "account.featured.new_collection": "Új gyűjtemény",
  "account.field_overflow": "Teljes tartalom megjelenítése",
  "account.filters.all": "Összes tevékenység",
  "account.filters.boosts_toggle": "Megtolások megjelenítése",
  "account.filters.posts_boosts": "Bejegyzések és megtolások",
  "account.filters.posts_only": "Bejegyzések",
  "account.filters.posts_replies": "Bejegyzések és válaszok",
  "account.filters.replies_toggle": "Válaszok megjelenítése",
  "account.follow": "Követés",
  "account.follow_back": "Viszontkövetés",
  "account.follow_back_short": "Visszakövetés",
  "account.follow_request": "Követési kérés",
  "account.follow_request_cancel": "Kérés törlése",
  "account.follow_request_cancel_short": "Mégse",
  "account.follow_request_short": "Kérés",
  "account.followers": "Követő",
  "account.followers.empty": "Ezt a felhasználót még senki sem követi.",
  "account.followers_counter": "{count, plural, one {{counter} követő} other {{counter} követő}}",
  "account.followers_you_know_counter": "{counter} ismerős",
  "account.following": "Követve",
  "account.following_counter": "{count, plural, one {{counter} követett} other {{counter} követett}}",
  "account.follows.empty": "Ez a felhasználó még senkit sem követ.",
  "account.follows_you": "Követ téged",
  "account.go_to_profile": "Ugrás a profilhoz",
  "account.hide_reblogs": "@{name} megtolásainak elrejtése",
  "account.in_memoriam": "Emlékünkben.",
  "account.join_modal.day": "Nap",
  "account.join_modal.me": "Ekkor csatlakoztál ide: {server}",
  "account.join_modal.me_anniversary": "Boldog Födinapot! Ekkor csatlakoztál ide: {server}",
  "account.join_modal.me_today": "Ez az első napod itt: {server}!",
  "account.join_modal.other": "{name} ekkor csatlakozott ide: {server}",
  "account.join_modal.other_today": "Ez {name} első napja itt: {server}!",
  "account.join_modal.share.celebrate": "Ünnepi bejegyzés megosztása",
  "account.join_modal.share.intro": "Bemutatkozó bejegyzés megosztása",
  "account.join_modal.share.welcome": "Üdvözlő bejegyzés megosztása",
  "account.join_modal.years": "{number, plural, one {év} other {év}}",
  "account.joined_short": "Csatlakozott",
  "account.languages": "Feliratkozott nyelvek módosítása",
  "account.last_active": "Utoljára aktív",
  "account.link_verified_on": "A linket eredetiségét ebben az időpontban ellenőriztük: {date}",
  "account.locked_info": "Ennek a fióknak zárolt a láthatósága. A tulajdonos kézzel engedélyezi, hogy ki követheti őt.",
  "account.media": "Média",
  "account.mention": "@{name} említése",
  "account.menu.add_to_list": "Hozzáadás listához…",
  "account.menu.block": "Fiók letiltása",
  "account.menu.block_domain": "{domain} letiltása",
  "account.menu.copied": "Fiókhivatkozás a vágólapra másolva",
  "account.menu.copy": "Hivatkozás másolása",
  "account.menu.direct": "Privát említés",
  "account.menu.hide_reblogs": "Megtolások elrejtése az idővonalon",
  "account.menu.mention": "Említés",
  "account.menu.mute": "Fiók némítása",
  "account.menu.note.description": "Csak te láthatod",
  "account.menu.open_original_page": "Megtekintés itt: {domain}",
  "account.menu.remove_follower": "Követő eltávolítása",
  "account.menu.report": "Fiók jelentése",
  "account.menu.share": "Megosztás…",
  "account.menu.show_reblogs": "Megtolások megjelenítése az idővonalon",
  "account.menu.unblock": "Fiók tiltásának feloldása",
  "account.menu.unblock_domain": "{domain} tiltásának feloldása",
  "account.menu.unmute": "Fiók némításának feloldása",
  "account.moved_to": "{name} jelezte, hogy az új fiókja a következő:",
  "account.mute": "@{name} némítása",
  "account.mute_notifications_short": "Értesítések némítása",
  "account.mute_short": "Némítás",
  "account.muted": "Némítva",
  "account.mutual": "Követitek egymást",
  "account.name.copy": "Fióknév másolása",
  "account.name.help.domain": "A(z) {domain} a kiszolgáló, amely a felhasználó profilját és bejegyzéseit szolgálja ki.",
  "account.name.help.domain_self": "A(z) {domain} a kiszolgáló, amely a profilodat és bejegyzéseidet szolgálja ki.",
  "account.name.help.footer": "Ahogy bárkinek küldhetsz e-mailt, annak is, aki más e-mail-szolgáltatót használ, úgy kapcsolatba léphetsz a más Mastodon-kiszolgálókon lévő emberekkel, és bárki mással, aki más Födiverzum-alkalmazást használ.",
  "account.name.help.header": "A fióknév olyan, mint egy e-mail-cím",
  "account.name.help.username": "Ez a fiók felhasználóneve a kiszolgálóján: {username}. Lehet, hogy másnak egy másik kiszolgálón ugyanez a felhasználóneve.",
  "account.name.help.username_self": "Ez a felhasználóneved ezen a kiszolgálón: {username}. Lehet, hogy másnak egy másik kiszolgálón ugyanez a felhasználóneve.",
  "account.name_info": "Mit jelent ez?",
  "account.no_bio": "Leírás nincs megadva.",
  "account.node_modal.callout": "A személyes megjegyzéseket csak te látod.",
  "account.node_modal.edit_title": "Személyes megjegyzés szerkesztése",
  "account.node_modal.error_unknown": "Nem sikerült a megjegyzés mentése",
  "account.node_modal.field_label": "Személyes megjegyzés",
  "account.node_modal.save": "Mentés",
  "account.node_modal.title": "Személyes megjegyzés hozzáadása",
  "account.note.edit_button": "Szerkesztés",
  "account.note.title": "Személyes megjegyzés (csak te látod)",
  "account.open_original_page": "Eredeti oldal megnyitása",
  "account.pending": "Függőben",
  "account.posts": "Bejegyzések",
  "account.remove_from_followers": "{name} eltávolítása a követők közül",
  "account.report": "@{name} jelentése",
  "account.requested_follow": "{name} kérte, hogy követhessen",
  "account.share": "@{name} profiljának megosztása",
  "account.show_reblogs": "@{name} megtolásainak mutatása",
  "account.statuses_counter": "{count, plural, one {{counter} bejegyzés} other {{counter} bejegyzés}}",
  "account.timeline.pinned": "Kitűzve",
  "account.timeline.pinned.view_all": "Összes kitűzött bejegyzés megtekintése",
  "account.unblock": "@{name} letiltásának feloldása",
  "account.unblock_domain": "{domain} domain tiltásának feloldása",
  "account.unblock_domain_short": "Tiltás feloldása",
  "account.unblock_short": "Tiltás feloldása",
  "account.unendorse": "Ne jelenjen meg a profilodon",
  "account.unfollow": "Követés megszüntetése",
  "account.unmute": "@{name} némításának feloldása",
  "account.unmute_notifications_short": "Értesítések némításának feloldása",
  "account.unmute_short": "Némitás feloldása",
  "account_edit.advanced_settings.bot_hint": "Jelzés másoknak, hogy ez a fiók automatikus műveleteket végez és valószínűleg nem figyeljük",
  "account_edit.advanced_settings.bot_label": "Automatizált fiók",
  "account_edit.advanced_settings.title": "Speciális beállítások",
  "account_edit.bio.add_label": "Bemutatkozás hozzáadása",
  "account_edit.bio.edit_label": "Bemutatkozás szerkesztése",
  "account_edit.bio.placeholder": "Adj meg egy rövid bemutatkozást, hogy mások könnyebben megtaláljanak.",
  "account_edit.bio.title": "Bemutatkozás",
  "account_edit.bio_modal.add_title": "Bemutatkozás hozzáadása",
  "account_edit.bio_modal.edit_title": "Bemutatkozás szerkesztése",
  "account_edit.column_button": "Kész",
  "account_edit.column_title": "Profil szerkesztése",
  "account_edit.custom_fields.add_label": "Mező hozzáadása",
  "account_edit.custom_fields.edit_label": "Mező szerkesztése",
  "account_edit.custom_fields.placeholder": "Add meg a névmásaidat, külső hivatkozásaidat vagy bármi mást, amelyet megosztanál.",
  "account_edit.custom_fields.reorder_button": "Mezők átrendezése",
  "account_edit.custom_fields.tip_content": "Könnyedén nagyobb hitelességet adhatsz a Mastodon-fiókodnak a saját weboldalaidra mutató hivatkozások megerősítésével.",
  "account_edit.custom_fields.tip_title": "Tipp: Ellenőrzött hivatkozások hozzáadása",
  "account_edit.custom_fields.title": "Egyéni mezők",
  "account_edit.custom_fields.verified_hint": "Hogyan kell ellenőrzött hivatkozást hozzáadni?",
  "account_edit.display_name.add_label": "Megjelenítendő név hozzáadása",
  "account_edit.display_name.edit_label": "Megjelenítendő név szerkesztése",
  "account_edit.display_name.placeholder": "A megjelenítendő név az, ahogy a neved megjelenik a profilodon és az idővonalakon.",
  "account_edit.display_name.title": "Megjelenítendő név",
  "account_edit.featured_hashtags.edit_label": "Hashtagek hozzáadása",
  "account_edit.featured_hashtags.placeholder": "Segíts másoknak, hogy azonosíthassák a kedvenc témáid, és gyorsan elérjék azokat.",
  "account_edit.featured_hashtags.title": "Kiemelt hashtagek",
  "account_edit.field_actions.delete": "Mező törlése",
  "account_edit.field_actions.edit": "Mező szerkesztése",
  "account_edit.field_delete_modal.confirm": "Biztos, hogy törlöd ezt az egyéni mezőt? Ez a művelet nem vonható vissza.",
  "account_edit.field_delete_modal.delete_button": "Törlés",
  "account_edit.field_delete_modal.title": "Egyéni mező törlése?",
  "account_edit.field_edit_modal.add_title": "Egyéni mező hozzáadása",
  "account_edit.field_edit_modal.discard_confirm": "Elvetés",
  "account_edit.field_edit_modal.discard_message": "Nem mentett módosításaid vannak. Biztos, hogy elveted?",
  "account_edit.field_edit_modal.edit_title": "Egyéni mező szerkesztése",
  "account_edit.field_edit_modal.length_warning": "Javasolt karakterkorlát túllépve. A mobilos felhasználók lehet, hogy nem fogják látni a teljes mezőt.",
  "account_edit.field_edit_modal.link_emoji_warning": "Nem javasoljuk az egyéni emodzsik és webcímek együttes használatát. A mindkettőt tartalmazó egyéni mezők a felhasználók megzavarásának elkerülése érdekében csak szövegként jelennek meg, nem hivatkozásként.",
  "account_edit.field_edit_modal.name_hint": "Például „Személyes webhely”",
  "account_edit.field_edit_modal.name_label": "Címke",
  "account_edit.field_edit_modal.url_warning": "Hivatkozás hozzáadásakor add meg a {protocol} protokollt az elején.",
  "account_edit.field_edit_modal.value_hint": "Például „https://example.me”",
  "account_edit.field_edit_modal.value_label": "Érték",
  "account_edit.field_reorder_modal.drag_cancel": "Az áthúzás megszakítva. A(z) „{item}” mező el lett dobva.",
  "account_edit.field_reorder_modal.drag_end": "A(z) „{item}” mező el lett dobva.",
  "account_edit.field_reorder_modal.drag_instructions": "Az egyéni mezők átrendezéséhez nyomj Szóközt vagy Entert. Húzás közben használd a nyílgombokat a mező felfelé vagy lefelé mozgatásához. A mező új pozícióba helyezéséhez nyomd meg a Szóközt vagy az Entert, vagy a megszakításhoz nyomd meg az Esc gombot.",
  "account_edit.field_reorder_modal.drag_move": "A(z) „{item}” mező át lett helyezve.",
  "account_edit.field_reorder_modal.drag_over": "A(z) „{item}” mező át lett helyezve ennek a helyére: „{over}”.",
  "account_edit.field_reorder_modal.drag_start": "A(z) „{item}” mező áthelyezéshez felvéve.",
  "account_edit.field_reorder_modal.handle_label": "A(z) „{item}” mező húzása",
  "account_edit.field_reorder_modal.title": "Mezők átrendezése",
  "account_edit.image_alt_modal.add_title": "Helyettesítő szöveg hozzáadása",
  "account_edit.image_alt_modal.details_content": "TEDD: <ul> <li>Írd le a képedet</li> <li>Használj egyes szám harmadik személyt (például „én” helyett „Alex”)</li> <li>Légy tömör – sokszor néhány szó is elég</li> </ul> NE TEDD: <ul> <li>Ne kezdd azzal, hogy „X fényképe” – a képernyőolvasók számára felesleges</li> </ul> Példa: <ul> <li>„Alex zöld inget és szemüveget viselve”</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Tippek: helyettesítő szöveg a profilképekhez",
  "account_edit.image_alt_modal.edit_title": "Helyettesítő szöveg szerkesztése",
  "account_edit.image_alt_modal.text_hint": "A helyettesítő szövegek segítenek a képernyőolvasót használóknak abban, hogy megértsék a tartalmat.",
  "account_edit.image_alt_modal.text_label": "Helyettesítő szöveg",
  "account_edit.image_delete_modal.confirm": "Biztos, hogy törlöd ezt a képet? Ez a művelet nem vonható vissza.",
  "account_edit.image_delete_modal.delete_button": "Törlés",
  "account_edit.image_delete_modal.title": "Törlöd a képet?",
  "account_edit.image_edit.add_button": "Kép hozzáadása",
  "account_edit.image_edit.alt_add_button": "Helyettesítő szöveg hozzáadása",
  "account_edit.image_edit.alt_edit_button": "Helyettesítő szöveg szerkesztése",
  "account_edit.image_edit.remove_button": "Kép eltávolítása",
  "account_edit.image_edit.replace_button": "Kép cseréje",
  "account_edit.item_list.delete": "{name} törlése",
  "account_edit.item_list.edit": "{name} szerkesztése",
  "account_edit.name_modal.add_title": "Megjelenítendő név hozzáadása",
  "account_edit.name_modal.edit_title": "Megjelenítendő név szerkesztése",
  "account_edit.profile_tab.button_label": "Testreszabás",
  "account_edit.profile_tab.hint.description": "Ezek a beállítások szabják testre, hogy a felhasználók mit látnak a(z) {server} kiszolgálón a hivatalos alkalmazásokban, de nem biztos, hogy a külső kiszolgálókon vagy alkalmazásokban is érvényesek lesznek.",
  "account_edit.profile_tab.hint.title": "A megjelenítés eltérő lehet",
  "account_edit.profile_tab.show_featured.description": "A „Kiemelt” egy nem kötelező lap, ahol más fiókokat mutathatsz be.",
  "account_edit.profile_tab.show_featured.title": "„Kiemelt” lap megjelenítése",
  "account_edit.profile_tab.show_media.description": "A „Média” egy nem kötelező lap, amely a képeket vagy videókat tartalmazó bejegyzéseidet jeleníti meg.",
  "account_edit.profile_tab.show_media.title": "„Média” lap megjelenítése",
  "account_edit.profile_tab.show_media_replies.description": "Ha engedélyezve van, akkor a Média lap megjeleníti a bejegyzéseidet és a mások bejegyzéseihez írt válaszaidat.",
  "account_edit.profile_tab.show_media_replies.title": "Válaszok megjelenítése a „Média” lapon",
  "account_edit.profile_tab.show_relations.description": "A profilodban megjeleníti azokat a fiókokat, melyeket követsz, valamint a többi felhasználó követőit. Mások továbbra is látni fogják, hogy követed-e őket.",
  "account_edit.profile_tab.show_relations.title": "„Követők” és „Követettek” megjelenítése",
  "account_edit.profile_tab.subtitle": "A profil megjelenítésének testreszabása.",
  "account_edit.profile_tab.title": "Profil megjelenítési beállításai",
  "account_edit.save": "Mentés",
  "account_edit.upload_modal.back": "Vissza",
  "account_edit.upload_modal.done": "Kész",
  "account_edit.upload_modal.next": "Következő",
  "account_edit.upload_modal.step_crop.zoom": "Nagyítás",
  "account_edit.upload_modal.step_upload.button": "Fájlok tallózása",
  "account_edit.upload_modal.step_upload.dragging": "Ejtsd ide a feltöltéshez",
  "account_edit.upload_modal.step_upload.header": "Válassz egy képet",
  "account_edit.upload_modal.step_upload.hint": "WEBP, PNG, GIF vagy JPG formátum, legfeljebb {limit} MB.{br}A kép ekkorára lesz méretezve: {width}×{height} px.",
  "account_edit.upload_modal.title_add.avatar": "Profilkép hozzáadása",
  "account_edit.upload_modal.title_add.header": "Borítókép hozzáadása",
  "account_edit.upload_modal.title_replace.avatar": "Profilkép cseréje",
  "account_edit.upload_modal.title_replace.header": "Borítókép cseréje",
  "account_edit.verified_modal.details": "Növeld a Mastodon-profilod hitelességét a személyes webhelyekre mutató hivatkozások ellenőrzésével. Így működik:",
  "account_edit.verified_modal.invisible_link.details": "A hivatkozás hozzáadása a fejlécedhez. A fontos rész a rel=\"me\", mely megakadályozza, hogy mások a nevedben lépjenek fel olyan oldalakon, ahol van felhasználók által előállított tartalom. A(z) {tag} helyett a „link” címkét is használhatod az oldal fejlécében, de a HTML-nek elérhetőnek kell lennie JavaScript futtatása nélkül is.",
  "account_edit.verified_modal.invisible_link.summary": "Hogyan lehet egy hivatkozás láthatatlanná tenni?",
  "account_edit.verified_modal.step1.header": "Másold a lenti HTML-kódot és illeszd be a webhelyed fejlécébe",
  "account_edit.verified_modal.step2.details": "Ha már egyéni mezőként hozzáadtad a webhelyedet, akkor törölnöd kell, újból hozzá kell adnod, hogy újra ellenőrizve legyen.",
  "account_edit.verified_modal.step2.header": "Saját webhely hozzáadása egyéni mezőként",
  "account_edit.verified_modal.title": "Hogyan kell ellenőrzött hivatkozást hozzáadni",
  "account_edit_tags.add_tag": "#{tagName} hozzáadása",
  "account_edit_tags.column_title": "Címkék szerkesztése",
  "account_edit_tags.help_text": "A kiemelt hashtagek segítenek a felhasználóknak abban, hogy interakcióba lépjenek a profiloddal. Szűrőként jelennek meg a Profil oldalad Tevékenység nézetében.",
  "account_edit_tags.max_tags_reached": "Elérted a kiemelt hashtagek maximális számát.",
  "account_edit_tags.search_placeholder": "Hashtag megadása…",
  "account_edit_tags.suggestions": "Javaslatok:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# bejegyzés} other {# bejegyzés}}",
  "account_list.hidden_notice": "Ezt csak te látod. A lista másoknak való megjelenítéshez ugorj ide: <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, one {# fiók} other {# fiók}}",
  "account_note.placeholder": "Kattintás jegyzet hozzáadásához",
  "admin.dashboard.daily_retention": "Napi regisztráció utáni felhasználómegtartási arány",
  "admin.dashboard.monthly_retention": "Havi regisztráció utáni felhasználómegtartási arány",
  "admin.dashboard.retention.average": "Átlag",
  "admin.dashboard.retention.cohort": "Regisztráció hónapja",
  "admin.dashboard.retention.cohort_size": "Új felhasználó",
  "admin.impact_report.instance_accounts": "Fiókprofilok, melyek törlődnének",
  "admin.impact_report.instance_followers": "Követők, akiket a mi felhasználóink elveszítenének",
  "admin.impact_report.instance_follows": "Követők, akiket az ő felhasználóik elveszítenének",
  "admin.impact_report.title": "Hatásvizsgálat",
  "alert.rate_limited.message": "Próbáld újra {retry_time, time, medium} után.",
  "alert.rate_limited.title": "Adatforgalom korlátozva",
  "alert.unexpected.message": "Váratlan hiba történt.",
  "alert.unexpected.title": "Hoppá!",
  "alt_text_badge.title": "Helyettesítő szöveg",
  "alt_text_modal.add_alt_text": "Helyettesítő szöveg hozzáadása",
  "alt_text_modal.add_text_from_image": "Szöveg hozzáadása a képből",
  "alt_text_modal.cancel": "Mégse",
  "alt_text_modal.change_thumbnail": "Bélyegkép megváltoztatása",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Írd le a hallássérültek számára…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Írd le a látássérültek számára…",
  "alt_text_modal.done": "Kész",
  "announcement.announcement": "Közlemény",
  "annual_report.announcement.action_build": "Saját Wrapstodon összeállítása",
  "annual_report.announcement.action_dismiss": "Nem, köszönöm",
  "annual_report.announcement.action_view": "Saját Wrapstodon megtekintése",
  "annual_report.announcement.description": "Fedezz fel többet a Mastodonon az elmúlt évben végzett tevékenységeidről.",
  "annual_report.announcement.title": "A Wrapstodon {year} megérkezett",
  "annual_report.nav_item.badge": "Új",
  "annual_report.shared_page.donate": "Adományozás",
  "annual_report.shared_page.footer": "A Mastodon által {heart}-tel előállítva",
  "annual_report.shared_page.footer_server_info": "{username} a {domain} domaint használja, amely a Mastodon által működtetett számos közösség egyike.",
  "annual_report.summary.archetype.booster.desc_public": "{name} megtolandó bejegyzésekre vadászott, tökéletes célzással felerősítve mások üzeneteit.",
  "annual_report.summary.archetype.booster.desc_self": "Megtolandó bejegyzésekre vadásztál, tökéletes célzással felerősítve mások üzeneteit.",
  "annual_report.summary.archetype.booster.name": "Az íjász",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Tudjuk, hogy {name} ott volt, valahol, a saját csendes módján élvezve a Mastodont.",
  "annual_report.summary.archetype.lurker.desc_self": "Tudjuk, hogy ott voltál, valahol, a saját csendes módodon élvezve a Mastodont.",
  "annual_report.summary.archetype.lurker.name": "A sztoikus",
  "annual_report.summary.archetype.oracle.desc_public": "{name} több bejegyzést hozott létre, mint választ, így a Mastodon friss és jövőbe tekintő marad.",
  "annual_report.summary.archetype.oracle.desc_self": "Több bejegyzést hoztál létre, mint választ, így a Mastodon friss és jövőbe tekintő marad.",
  "annual_report.summary.archetype.oracle.name": "Az orákulum",
  "annual_report.summary.archetype.pollster.desc_public": "{name} több szavazást hozott létre, mint bármilyen más bejegyzést, ezzel támogatva a kíváncsiságot a Mastodonon.",
  "annual_report.summary.archetype.pollster.desc_self": "Több szavazást hoztál létre, mint bármilyen más bejegyzést, ezzel támogatva a kíváncsiságot a Mastodonon.",
  "annual_report.summary.archetype.pollster.name": "A csodálkozó",
  "annual_report.summary.archetype.replier.desc_public": "{name} gyakran válaszolt más emberek bejegyzéseire, új témákat porozva be a Mastodonon.",
  "annual_report.summary.archetype.replier.desc_self": "Gyakran válaszoltál más emberek bejegyzéseire, új témákat porozva be a Mastodonon.",
  "annual_report.summary.archetype.replier.name": "A pillangó",
  "annual_report.summary.archetype.reveal": "Saját archetípus felfedése",
  "annual_report.summary.archetype.reveal_description": "Köszönjük, hogy a Mastodon része vagy! Tudj meg többet az archetípusodról {year} évében.",
  "annual_report.summary.archetype.title_public": "{name} archetípusa",
  "annual_report.summary.archetype.title_self": "Saját archetípus",
  "annual_report.summary.close": "Bezárás",
  "annual_report.summary.copy_link": "Hivatkozás másolása",
  "annual_report.summary.followers.new_followers": "{count, plural, one {új követő} other {új követők}}",
  "annual_report.summary.highlighted_post.boost_count": "Ez a bejegyzés {count, plural, one {egyszer} other {# alkalommal}} volt megtolva.",
  "annual_report.summary.highlighted_post.favourite_count": "Ez a bejegyzés {count, plural, one {egyszer} other {# alkalommal}} volt kedvencnek jelölve.",
  "annual_report.summary.highlighted_post.reply_count": "Ez a bejegyzés {count, plural, one {egy választ} other {# választ}} kapott.",
  "annual_report.summary.highlighted_post.title": "Legnépszerűbb bejegyzés",
  "annual_report.summary.most_used_app.most_used_app": "legtöbbet használt app",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "legtöbbet használt hashtag",
  "annual_report.summary.most_used_hashtag.used_count": "Ez a hashtag {count, plural, one {egy bejegyzésedben} other {# bejegyzésedben}} szerepel.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} {count, plural, one {egy bejegyzésében} other {# bejegyzésében}} használta ezt a hashtaget.",
  "annual_report.summary.new_posts.new_posts": "új bejegyzés",
  "annual_report.summary.percentile.text": "<topLabel>Ezzel a csúcs</topLabel><percentage></percentage><bottomLabel>{domain} felhasználó között vagy.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Nem mondjuk el Bernie-nek.",
  "annual_report.summary.share_elsewhere": "Megosztás máshol",
  "annual_report.summary.share_message": "{archetype} lett az archetípusom!",
  "annual_report.summary.share_on_mastodon": "Megosztás a Mastodonon",
  "attachments_list.unprocessed": "(feldolgozatlan)",
  "audio.hide": "Hang elrejtése",
  "block_modal.no_collections": "Egyikőtök sem adhatja hozzá a másikat gyűjteményekhez. Automatikusan el is lesztek távolítva az egymás gyűjteményéből.",
  "block_modal.remote_users_caveat": "Arra kérjük a {domain} kiszolgálót, hogy tartsa tiszteletben a döntésedet. Ugyanakkor az együttműködés nem garantált, mivel néhány kiszolgáló másképp kezelheti a letiltásokat. A nyilvános bejegyzések a be nem jelentkezett felhasználók számára továbbra is látszódhatnak.",
  "block_modal.show_less": "Kevesebb mutatása",
  "block_modal.show_more": "Több mutatása",
  "block_modal.they_cant_mention": "Nem említhetik meg, követhetik vagy idézhetik egymást.",
  "block_modal.they_cant_see_posts": "Nem láthatja a tartalmadat, és te sem fogod látni az övéit.",
  "block_modal.they_will_know": "Láthatja, hogy le van tiltva.",
  "block_modal.title": "Letiltsuk a felhasználót?",
  "block_modal.you_wont_see_mentions": "Nem fogod látni az őt említő bejegyzéseket.",
  "boost_modal.combo": "Hogy átugord ezt következő alkalommal, használd {combo}",
  "boost_modal.reblog": "Bejegyzés megtolása?",
  "boost_modal.undo_reblog": "Megtolás visszavonása?",
  "bundle_column_error.copy_stacktrace": "Hibajelentés másolása",
  "bundle_column_error.error.body": "A kért lap nem jeleníthető meg. Ez lehet, hogy kódhiba, vagy böngészőkompatibitási hiba.",
  "bundle_column_error.error.title": "Jaj ne!",
  "bundle_column_error.network.body": "Hiba történt az oldal betöltése során. Ezt az internetkapcsolat ideiglenes problémája vagy kiszolgálóhiba is okozhatja.",
  "bundle_column_error.network.title": "Hálózati hiba",
  "bundle_column_error.retry": "Próbáld újra",
  "bundle_column_error.return": "Vissza a kezdőlapra",
  "bundle_column_error.routing.body": "A kért oldal nem található. Biztos, hogy a címsávban lévő webcím helyes?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Bezárás",
  "bundle_modal_error.message": "Hiba történt a képernyő betöltésekor.",
  "bundle_modal_error.retry": "Próbáld újra",
  "callout.dismiss": "Elvetés",
  "carousel.current": "{current, number}. <sr>dia</sr> / {max, number}",
  "carousel.slide": "{current, number}. dia / {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} javasolt karakter",
  "character_counter.required": "{currentLength}/{maxLength} karakter",
  "closed_registrations.other_server_instructions": "Mivel a Mastdon decentralizált, létrehozhatsz egy fiókot egy másik kiszolgálón és mégis kapcsolódhatsz ehhez.",
  "closed_registrations_modal.description": "Fiók létrehozása a {domain} kiszolgálón jelenleg nem lehetséges, de jó, ha tudod, hogy nem szükséges fiókkal rendelkezni pont a {domain} kiszolgálón, hogy használhasd a Mastodont.",
  "closed_registrations_modal.find_another_server": "Másik kiszolgáló keresése",
  "closed_registrations_modal.preamble": "A Mastodon decentralizált, így teljesen mindegy, hol hozod létre a fiókodat, követhetsz és kapcsolódhatsz bárkivel ezen a kiszolgálón is. Saját magad is üzemeltethetsz kiszolgálót!",
  "closed_registrations_modal.title": "Regisztráció a Mastodonra",
  "collection.share_modal.share_link_label": "Hivatkozás megosztása",
  "collection.share_modal.share_via_post": "Közzététel a Mastodonon",
  "collection.share_modal.share_via_system": "Megosztás…",
  "collection.share_modal.title": "Gyűjtemény megosztása",
  "collection.share_modal.title_new": "Oszd meg az új gyűjteményedet!",
  "collection.share_template_other": "Nézd meg ezt a gyűjteményt: {link}",
  "collection.share_template_own": "Nézd meg az új gyűjteményemet: {link}",
  "collections.account_count": "{count, plural, one {# fiók} other {# fiók}}",
  "collections.accounts.empty_description": "Adj hozzá legfeljebb {count} fiókot",
  "collections.accounts.empty_editor_title": "Még senki sincs ebben a gyűjteményben",
  "collections.accounts.empty_title": "Ez a gyűjtemény üres",
  "collections.block_collection_owner": "Fiók letiltása",
  "collections.by_account": "szerző: {account_handle}",
  "collections.collection_description": "Leírás",
  "collections.collection_language": "Nyelv",
  "collections.collection_language_none": "Egyik sem",
  "collections.collection_name": "Név",
  "collections.collection_topic": "Téma",
  "collections.confirm_account_removal": "Biztos, hogy eltávolítod ezt a fiókot ebből a gyűjteményből?",
  "collections.content_warning": "Tartalmi figyelmeztetés",
  "collections.continue": "Folytatás",
  "collections.copy_link": "Hivatkozás másolása",
  "collections.copy_link_confirmation": "Gyűjteményhivatkozás vágólapra másolva",
  "collections.create.accounts_title": "Kit emelsz ki ebben a gyűjteményben?",
  "collections.create.basic_details_title": "Alapvető részletek",
  "collections.create.steps": "{step}. lépés/{total}",
  "collections.create_collection": "Gyűjtemény létrehozása",
  "collections.delete_collection": "Gyűjtemény törlése",
  "collections.description_length_hint": "100 karakteres korlát",
  "collections.detail.author_added_you_on_date": "{author} hozzáadott ekkor: {date}",
  "collections.detail.loading": "Gyűjtemény betöltése…",
  "collections.detail.revoke_inclusion": "Saját magam eltávolítása",
  "collections.detail.sensitive_content": "Kényes tartalom",
  "collections.detail.sensitive_note": "Ebben a gyűjteményben egyesek számára érzékeny fiókok és tartalmak vannak.",
  "collections.detail.share": "Gyűjtemény megosztása",
  "collections.detail.you_are_in_this_collection": "Kiemeltek téged ebben a gyűjteményhez",
  "collections.edit_details": "Részletek szerkesztése",
  "collections.error_loading_collections": "Hiba történt ezeknek a gyűjteményeknek a betöltése során.",
  "collections.hidden_accounts_description": "Blokkoltad vagy letiltottad {count, plural, one {ezt a felhasználót} other {ezeket a felhasználókat}}",
  "collections.hidden_accounts_link": "{count, plural, one {# rejtett fiók} other {# rejtett fiók}}",
  "collections.hints.accounts_counter": "{count}/{max} fiók",
  "collections.last_updated_at": "Utoljára frissítve: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# gyűjtemény} other {# gyűjtemény}}",
  "collections.list.created_by_author": "Létrehozta: {name}",
  "collections.list.created_by_you": "Te hoztad létre",
  "collections.list.featuring_you": "Tartalmaz téged",
  "collections.manage_accounts": "Fiókok kezelése",
  "collections.mark_as_sensitive": "Megjelelölés érzénykenként",
  "collections.mark_as_sensitive_hint": "Tartalmi figyelmeztetés mögé rejti a gyűjtemény leírását és a fiókokat. A gyűjtemény neve továbbra is látható lesz.",
  "collections.maximum_collection_count_description": "A kiszolgáló legfeljebb {count} gyűjtemény létrehozását engedélyezi.",
  "collections.maximum_collection_count_reached": "Elérted a gyűjtemények maximális számát",
  "collections.name_length_hint": "40 karakteres korlát",
  "collections.new_collection": "Új gyűjtemény",
  "collections.pending_accounts.message": "A fiókok függőben lévőként jelenhetnek meg, ha a felhasználó vagy a kiszolgálója válaszára várunk. Csak te láthatod a függőben lévő fiókokat.",
  "collections.pending_accounts.title": "Miért látom a függőben lévő fiókokat?",
  "collections.remove_account": "Eltávolítás",
  "collections.report_collection": "Gyűjtemény jelentése",
  "collections.revoke_collection_inclusion": "Saját magam eltávolítása ebből a gyűjteményből",
  "collections.revoke_inclusion.confirmation": "El lettél távolítva innen: „{collection}”",
  "collections.revoke_inclusion.error": "Hiba történt, próbáld újra később.",
  "collections.search_accounts_label": "Hozzáadandó fiók keresése",
  "collections.search_accounts_max_reached": "Elérte a hozzáadott fiókok maximális számát",
  "collections.sensitive": "Érzékeny",
  "collections.share_short": "Megosztás",
  "collections.suggestions.can_not_add": "Nem adható hozzá",
  "collections.suggestions.can_not_add_desc": "Ezek a fiókok lehet, hogy a felfedezés kikapcsolását kérték, vagy olyan kiszolgálón lehetnek, mely nem támogatja a gyűjteményeket.",
  "collections.suggestions.must_follow": "Először követni kell",
  "collections.suggestions.must_follow_desc": "Ezek a fiókok átnézik az összes követési kéréseket. A követőik adhatják őket gyűjteményekhez.",
  "collections.topic_hint": "Egy hashtag hozzáadása segít másoknak abban, hogy megértsék a gyűjtemény fő témáját.",
  "collections.topic_special_chars_hint": "A különleges karakterek mentéskor el lesznek távolítva",
  "collections.unlisted_collections_description": "Ezek nem jelennek meg a profilodon másoknak. A hivatkozással rendelkezők fedezhetik fel őket.",
  "collections.unlisted_collections_with_count": "Fel nem sorolt gyűjtemények ({count})",
  "collections.view_collection": "Gyűjtemény megtekintése",
  "collections.visibility_public": "Nyilvános",
  "collections.visibility_public_hint": "Felfedezhető a keresési találatokban és az egyéb helyeken, ahol ajánlások jelennek meg.",
  "collections.visibility_title": "Láthatóság",
  "collections.visibility_unlisted": "Nem listázott",
  "collections.visibility_unlisted_hint": "A hivatkozással bárki számára látható. A keresési találatokban és ajánlásokban rejtve van.",
  "column.about": "Névjegy",
  "column.blocks": "Letiltott felhasználók",
  "column.bookmarks": "Könyvjelzők",
  "column.community": "Helyi idővonal",
  "column.create_list": "Lista létrehozása",
  "column.direct": "Személyes említések",
  "column.directory": "Profilok böngészése",
  "column.domain_blocks": "Letiltott domainek",
  "column.edit_list": "Lista módosítása",
  "column.favourites": "Kedvencek",
  "column.firehose": "Hírfolyamok",
  "column.firehose_local": "Élő hírfolyam a kiszolgálóhoz",
  "column.firehose_singular": "Élő hírfolyam",
  "column.follow_requests": "Követési kérések",
  "column.home": "Kezdőlap",
  "column.list_members": "Listatagok kezelése",
  "column.lists": "Listák",
  "column.mutes": "Némított felhasználók",
  "column.notifications": "Értesítések",
  "column.other_collections": "{name} gyűjteményei",
  "column.pins": "Kitűzött bejegyzések",
  "column.public": "Föderációs idővonal",
  "column.your_collections": "Saját gyűjtemények",
  "column_back_button.label": "Vissza",
  "column_header.hide_settings": "Beállítások elrejtése",
  "column_header.moveLeft_settings": "Oszlop áthelyezése balra",
  "column_header.moveRight_settings": "Oszlop áthelyezése jobbra",
  "column_header.pin": "Kitűzés",
  "column_header.show_settings": "Beállítások megjelenítése",
  "column_header.unpin": "Kitűzés eltávolítása",
  "column_search.cancel": "Mégse",
  "combobox.close_results": "Találatok bezárása",
  "combobox.loading": "Betöltés",
  "combobox.no_results_found": "Nincs találat ehhez a kereséshez",
  "combobox.open_results": "Találatok megtekintése",
  "combobox.results_available": "{count, plural, one {# javaslat} other {# javaslat}} érhető el. A navigációhoz használt a fel és le nyílbillentyűket. A kiválasztáshoz üss Entert.",
  "community.column_settings.local_only": "Csak helyi",
  "community.column_settings.media_only": "Csak média",
  "community.column_settings.remote_only": "Csak távoli",
  "compose.error.blank_post": "A bejegyzés nem lehet üres.",
  "compose.language.change": "Nyelv megváltoztatása",
  "compose.language.search": "Nyelvek keresése…",
  "compose.published.body": "A bejegyzés publikálásra került.",
  "compose.published.open": "Megnyitás",
  "compose.saved.body": "A bejegyzés mentve.",
  "compose_form.direct_message_warning_learn_more": "Tudj meg többet",
  "compose_form.encryption_warning": "A bejegyzések a Mastodonon nem használnak végpontok közti titkosítást. Ne ossz meg semmilyen érzékeny információt a Mastodonon.",
  "compose_form.hashtag_warning": "Ez a bejegyzésed nem fog megjelenni semmilyen hashtag alatt, mivel nem nyilvános. Csak a nyilvános bejegyzések kereshetők hashtaggel.",
  "compose_form.lock_disclaimer": "A fiókod nincs {locked}. Bárki követni tud, hogy megtekintse a kizárólag követőknek szánt bejegyzéseket.",
  "compose_form.lock_disclaimer.lock": "zárolva",
  "compose_form.placeholder": "Mi jár a fejedben?",
  "compose_form.poll.duration": "Szavazás időtartama",
  "compose_form.poll.multiple": "Több lehetőség",
  "compose_form.poll.option_placeholder": "Válasz {number}",
  "compose_form.poll.single": "Feleletválasztós",
  "compose_form.poll.switch_to_multiple": "Szavazás megváltoztatása több választásosra",
  "compose_form.poll.switch_to_single": "Szavazás megváltoztatása egyetlen választásosra",
  "compose_form.poll.type": "Stílus",
  "compose_form.publish": "Közzététel",
  "compose_form.reply": "Válasz",
  "compose_form.save_changes": "Frissítés",
  "compose_form.spoiler.marked": "Tartalmi figyelmeztetés eltávolítása",
  "compose_form.spoiler.unmarked": "Tartalmi figyelmeztetés hozzáadása",
  "compose_form.spoiler_placeholder": "Tartalmi figyelmeztetés (opcionális)",
  "confirmation_modal.cancel": "Mégsem",
  "confirmations.block.confirm": "Letiltás",
  "confirmations.delete.confirm": "Törlés",
  "confirmations.delete.message": "Biztos, hogy törölni szeretnéd ezt a bejegyzést?",
  "confirmations.delete.title": "Törlöd a bejegyzést?",
  "confirmations.delete_collection.confirm": "Törlés",
  "confirmations.delete_collection.message": "Ez a művelet nem vonható vissza.",
  "confirmations.delete_collection.title": "Törlöd a következőt: „{name}”?",
  "confirmations.delete_list.confirm": "Törlés",
  "confirmations.delete_list.message": "Biztos, hogy véglegesen törölni szeretnéd ezt a listát?",
  "confirmations.delete_list.title": "Törlöd a listát?",
  "confirmations.discard_draft.confirm": "Elvetés és folytatás",
  "confirmations.discard_draft.edit.cancel": "Szerkesztés folytatása",
  "confirmations.discard_draft.edit.message": "A folytatással elveted a jelenleg szerkesztett bejegyzés esetleges változtatásait.",
  "confirmations.discard_draft.edit.title": "Elveted a bejegyzés változtatásait?",
  "confirmations.discard_draft.post.cancel": "Piszkozat folytatása",
  "confirmations.discard_draft.post.message": "A folytatással elveted a jelenleg írt bejegyzést.",
  "confirmations.discard_draft.post.title": "Elveted a piszkozatot?",
  "confirmations.discard_edit_media.confirm": "Elvetés",
  "confirmations.discard_edit_media.message": "Mentetlen változtatásaid vannak a média leírásában vagy előnézetében, mindenképp elveted?",
  "confirmations.follow_to_list.confirm": "Követés, és hozzáadás a listához",
  "confirmations.follow_to_list.message": "Követned kell {name} felhasználót, hogy hozzáadhasd a listához.",
  "confirmations.follow_to_list.title": "Felhasználó követése?",
  "confirmations.hide_featured_tab.confirm": "Lap elrejtése",
  "confirmations.hide_featured_tab.intro": "Ezt bármikor megváltoztathatod a <i>Profil szerkesztése > Profillap beállításai</i> alatt.",
  "confirmations.hide_featured_tab.message": "Ez elrejti a lapot a(z) {serverName} és más olyan kiszolgálók felhasználói elől, amelyek a Mastodon legfrissebb verzióját futtatják. Más esetekben a megjelenítés eltérhet.",
  "confirmations.hide_featured_tab.title": "Elrejti a „Kiemelt” lapot?",
  "confirmations.logout.confirm": "Kijelentkezés",
  "confirmations.logout.message": "Biztos, hogy kijelentkezel?",
  "confirmations.logout.title": "Kijelentkezel?",
  "confirmations.missing_alt_text.confirm": "Helyettesítő szöveg hozzáadása",
  "confirmations.missing_alt_text.message": "A bejegyzés helyettesítő szöveg nélküli médiát tartalmaz. A leírások hozzáadása segít a tartalom akadálymentesebbé tételében.",
  "confirmations.missing_alt_text.secondary": "Közzététel mindenképpen",
  "confirmations.missing_alt_text.title": "Helyettesítő szöveg hozzáadása?",
  "confirmations.mute.confirm": "Némítás",
  "confirmations.private_quote_notify.cancel": "Vissza a szerkesztéshez",
  "confirmations.private_quote_notify.confirm": "Bejegyzés közzététele",
  "confirmations.private_quote_notify.do_not_show_again": "Ne jelenítse meg újra ezt az üzenetet",
  "confirmations.private_quote_notify.message": "Akit idézel, és a többi megemlített értesítve lesz, és megtekinthetik a bejegyzésed, még akkor is, ha nem követnek.",
  "confirmations.private_quote_notify.title": "Megosztás a követőkkel és a megemlített felhasználókkal?",
  "confirmations.quiet_post_quote_info.dismiss": "Ne emlékeztessen újra",
  "confirmations.quiet_post_quote_info.got_it": "Rendben",
  "confirmations.quiet_post_quote_info.message": "Ha csendes nyilvános bejegyzést idézel, akkor a bejegyzés el lesz rejtve a felkapottak idővonalairól.",
  "confirmations.quiet_post_quote_info.title": "Csendes nyilvános bejegyzések idézése",
  "confirmations.redraft.confirm": "Törlés és újraírás",
  "confirmations.redraft.message": "Biztos, hogy ezt a bejegyzést szeretnéd törölni és újraírni? Minden megtolást és kedvencnek jelölést elvesztesz, az eredetire adott válaszok pedig elárvulnak.",
  "confirmations.redraft.title": "Törlöd és újraírod a bejegyzést?",
  "confirmations.remove_from_followers.confirm": "Követő eltávolítása",
  "confirmations.remove_from_followers.message": "{name} követ téged. Biztos, hogy folytatod?",
  "confirmations.remove_from_followers.title": "Követő eltávolítása?",
  "confirmations.revoke_collection_inclusion.confirm": "Saját magam eltávolítása",
  "confirmations.revoke_collection_inclusion.message": "Ez a művelet végleges, és a kurátor nem fog tudni újra hozzáadni ehhez a gyűjteményhez.",
  "confirmations.revoke_collection_inclusion.title": "Eltávolítod magadat ebből a gyűjteményből?",
  "confirmations.revoke_quote.confirm": "Bejegyzés eltávolítása",
  "confirmations.revoke_quote.message": "Ez a művelet nem vonható vissza.",
  "confirmations.revoke_quote.title": "Bejegyzés eltávolítása?",
  "confirmations.unblock.confirm": "Tiltás feloldása",
  "confirmations.unblock.title": "{name} tiltásának feloldása?",
  "confirmations.unfollow.confirm": "Követés visszavonása",
  "confirmations.unfollow.title": "{name} követésének megszüntetése?",
  "confirmations.withdraw_request.confirm": "Kérés visszavonása",
  "confirmations.withdraw_request.title": "{name} követése kérésének visszavonása?",
  "content_warning.hide": "Bejegyzés elrejtése",
  "content_warning.show": "Megjelenítés mindenképp",
  "content_warning.show_more": "Több megjelenítése",
  "content_warning.show_short": "Megjelenítés",
  "conversation.delete": "Beszélgetés törlése",
  "conversation.mark_as_read": "Megjelölés olvasottként",
  "conversation.open": "Beszélgetés megtekintése",
  "conversation.with": "Velük: {names}",
  "copy_icon_button.copied": "A szöveg a vágólapra másolva",
  "copy_icon_button.copy_this_text": "Hivatkozás vágólapra másolása",
  "copypaste.copied": "Másolva",
  "copypaste.copy_to_clipboard": "Másolás vágólapra",
  "directory.federated": "Az ismert födiverzumból",
  "directory.local": "Csak {domain} tartományból",
  "directory.new_arrivals": "Új csatlakozók",
  "directory.recently_active": "Nemrég aktív",
  "disabled_account_banner.account_settings": "Fiókbeállítások",
  "disabled_account_banner.text": "A(z) {disabledAccount} fiókod jelenleg le van tiltva.",
  "dismissable_banner.community_timeline": "Ezek a legfrissebb nyilvános bejegyzések, amelyeket a(z) {domain} kiszolgáló fiókjait használó emberek tették közzé.",
  "dismissable_banner.dismiss": "Elvetés",
  "dismissable_banner.public_timeline": "Ezek a legfrissebb nyilvános bejegyzések a födiverzumban lévő emberektől, akiket a(z) {domain} felhasználói követnek.",
  "domain_block_modal.block": "Kiszolgáló letiltása",
  "domain_block_modal.block_account_instead": "Helyette @{name} letiltása",
  "domain_block_modal.they_can_interact_with_old_posts": "Az ezen a kiszolgálón lévő emberek interaktálhatnak a régi bejegyzéseiddel.",
  "domain_block_modal.they_cant_follow": "Erről a kiszolgálóról senki sem követhet.",
  "domain_block_modal.they_wont_know": "Nem fogja tudni, hogy letiltották.",
  "domain_block_modal.title": "Letiltsuk a domaint?",
  "domain_block_modal.you_will_lose_num_followers": "El fogsz veszíteni {followersCount, plural, one {{followersCountDisplay} követőt} other {{followersCountDisplay} követőt}} és {followingCount, plural, one {{followingCountDisplay} követett személyt} other {{followingCountDisplay} követett személyt}}.",
  "domain_block_modal.you_will_lose_relationships": "Minden követőt és követett személyt el fogsz veszíteni erről a kiszolgálóról.",
  "domain_block_modal.you_wont_see_posts": "Nem látsz majd bejegyzéseket vagy értesítéseket ennek a kiszolgálónak a felhasználóitól.",
  "domain_pill.activitypub_lets_connect": "Lehetővé teszi, hogy kapcsolatba lépj nem csak a Mastodonon, hanem a más közösségi alkalmazásokon lévő emberekkel is.",
  "domain_pill.activitypub_like_language": "Az ActivityPub olyan mint egy nyelv, amelyet a Mastodon a más közösségi hálózatokkal való kommunikációra használ.",
  "domain_pill.server": "Kiszolgáló",
  "domain_pill.their_handle": "A fiókneve:",
  "domain_pill.their_server": "A digitális otthona, ahol a bejegyzései találhatók.",
  "domain_pill.their_username": "Az egyedi azonosítója a kiszolgálóján. Lehet, hogy ugyanazon felhasználónév különböző kiszolgálókon is megtalálható.",
  "domain_pill.username": "Felhasználónév",
  "domain_pill.whats_in_a_handle": "Mi is egy fióknév?",
  "domain_pill.who_they_are": "Mivel a fióknevek mondják meg, hogy valaki kicsoda és hol található, így ezek használatával léphetsz kapcsolatba az <button>ActivityPubot használó platformok</button> közösségi hálózatán lévő emberekkel.",
  "domain_pill.who_you_are": "Mivel a fiókneved mondja meg, hogy ki vagy és hol, így ezek használatával léphetnek kapcsolatba veled az <button>ActivityPubot használó platformok</button> közösségi hálózatán lévő emberek.",
  "domain_pill.your_handle": "Saját fióknév:",
  "domain_pill.your_server": "A digitális otthonod, ahol a bejegyzéseid találhatók. Nem tetszik a mostani? Válts kiszolgálót bármikor, és vidd magaddal a követőidet is.",
  "domain_pill.your_username": "Az egyedi azonosítód ezen a kiszolgálón. Lehet, hogy ugyanazon felhasználónév különböző kiszolgálókon is megtalálható.",
  "dropdown.empty": "Válassz egy lehetőséget",
  "email_subscriptions.email": "E-mail-cím",
  "email_subscriptions.form.action": "Feliratkozás",
  "email_subscriptions.form.bottom": "Kapj bejegyzéseket a postaládádba anélkül, hogy Mastodon-fiókot hoznál létre. Bármikor leiratkozhatsz. További információkért nézd meg az <a>Adatvédelmi irányelveket</a>.",
  "email_subscriptions.form.title": "Regisztrálj {name} e-mailben küldött híreiért",
  "email_subscriptions.submitted.lead": "Ellenőrizd a postaládádat az e-mailes hírek regisztrációs folyamatának befejezéséhez.",
  "email_subscriptions.submitted.title": "Csak még egy lépés",
  "email_subscriptions.validation.email.blocked": "E-mail-szolgáltató blokkolva",
  "email_subscriptions.validation.email.invalid": "Érvénytelen e-mail-cím",
  "embed.instructions": "Ágyazd be ezt a bejegyzést a weboldaladba az alábbi kód kimásolásával.",
  "embed.preview": "Így fog kinézni:",
  "emoji_button.activity": "Tevékenység",
  "emoji_button.clear": "Törlés",
  "emoji_button.custom": "Egyedi",
  "emoji_button.flags": "Zászlók",
  "emoji_button.food": "Étel és Ital",
  "emoji_button.label": "Emodzsi beszúrása",
  "emoji_button.nature": "Természet",
  "emoji_button.not_found": "Nem találhatók emodzsik",
  "emoji_button.objects": "Tárgyak",
  "emoji_button.people": "Emberek",
  "emoji_button.recent": "Gyakran használt",
  "emoji_button.search": "Keresés...",
  "emoji_button.search_results": "Keresési találatok",
  "emoji_button.symbols": "Szimbólumok",
  "emoji_button.travel": "Utazás és helyek",
  "empty_column.account_featured.other": "{acct} még nem emelt ki semmit.",
  "empty_column.account_featured_self.no_collections_button": "Gyűjtemény létrehozása",
  "empty_column.account_featured_self.no_collections_hide_tab": "Inkább a lap elrejtése",
  "empty_column.account_featured_self.pre_collections": "Készülj fel a gyűjteményekre",
  "empty_column.account_featured_self.pre_collections_desc": "A gyűjtemények (a Mastodon 4.6-ban érkezik) lehetővé teszik, hogy létrehozd a saját válogatott fióklistáidat, és ajánld másoknak.",
  "empty_column.account_featured_self.showcase_accounts": "Emeld ki a kedvenc fiókjaidat",
  "empty_column.account_featured_self.showcase_accounts_desc": "A gyűjtemények fiókok válogatott listái, melyek segítenek másoknak a Födiverzum még nagyobb részének felfedezésében.",
  "empty_column.account_featured_unknown.other": "Ez a fiók még nem emelt ki semmit.",
  "empty_column.account_hides_collections": "Ez a felhasználó úgy döntött, hogy nem teszi elérhetővé ezt az információt.",
  "empty_column.account_suspended": "Fiók felfüggesztve",
  "empty_column.account_timeline": "Itt nincs bejegyzés!",
  "empty_column.account_unavailable": "A profil nem érhető el",
  "empty_column.blocks": "Még senkit sem tiltottál le.",
  "empty_column.bookmarked_statuses": "Még nincs egyetlen könyvjelzőzött bejegyzésed sem. Ha könyvjelzőzöl egyet, itt fog megjelenni.",
  "empty_column.collections.featured_in": "Még nem adtak hozzá egyetlen gyűjteményhez sem.",
  "empty_column.community": "A helyi idővonal üres. Tégy közzé valamit nyilvánosan, hogy elindítsd az eseményeket!",
  "empty_column.direct": "Még nincs egy személyes említésed sem. Küldéskor vagy fogadáskor itt fognak megjelenni.",
  "empty_column.disabled_feed": "A kiszolgálód rendszergazdái letiltották ezt a hírfolyamot.",
  "empty_column.domain_blocks": "Még nem lett letiltva egyetlen domain sem.",
  "empty_column.explore_statuses": "Jelenleg semmi sem felkapott. Nézz vissza később!",
  "empty_column.favourited_statuses": "Még nincs egyetlen kedvenc bejegyzésed sem. Ha kedvencnek jelölsz egyet, itt fog megjelenni.",
  "empty_column.favourites": "Még senki sem jelölte ezt a bejegyzést kedvencnek. Ha valaki mégis megteszi, itt fogjuk mutatni.",
  "empty_column.follow_requests": "Még nincs egy követési kérésed sem. Ha kapsz egyet, itt fogjuk feltüntetni.",
  "empty_column.followed_tags": "Még egy hashtaget sem követtél be. Itt fognak megjelenni, ahogy bekövetsz egyet.",
  "empty_column.hashtag": "Jelenleg nem található semmi ezzel a hashtaggel.",
  "empty_column.home": "A saját idővonalad üres! Kövess további embereket ennek megtöltéséhez.",
  "empty_column.list": "A lista jelenleg üres. Ha a listatagok bejegyzést tesznek közzé, itt fog megjelenni.",
  "empty_column.mutes": "Még egy felhasználót sem némítottál le.",
  "empty_column.notification_requests": "Minden tiszta! Itt nincs semmi. Ha új értesítéseket kapsz, azok itt jelennek meg a beállításoknak megfelelően.",
  "empty_column.notifications": "Jelenleg még nincsenek értesítéseid. Ha mások kapcsolatba lépnek veled, ezek itt lesznek láthatóak.",
  "empty_column.public": "Jelenleg itt nincs semmi! Írj valamit nyilvánosan vagy kövess más kiszolgálón levő felhasználókat, hogy megtöltsd.",
  "empty_state.no_results": "Nincs találat",
  "error.no_hashtag_feed_access": "Csatlakozz vagy jelentkezz be, hogy megtekintsd és kövesd ezt a hashtaget.",
  "error.unexpected_crash.explanation": "Egy kód- vagy böngészőkompatibilitási hiba miatt ez az oldal nem jeleníthető meg helyesen.",
  "error.unexpected_crash.explanation_addons": "Ezt az oldalt nem lehet helyesen megjeleníteni. Ezt a hibát valószínűleg egy böngésző kiegészítő vagy egy automatikus fordító okozza.",
  "error.unexpected_crash.next_steps": "Próbáld frissíteni az oldalt. Ha ez nem segít, egy másik böngészőn vagy appon keresztül még mindig használhatod a Mastodont.",
  "error.unexpected_crash.next_steps_addons": "Próbáld letiltani őket és frissíteni az oldalt. Ha ez nem segít, egy másik böngészőn vagy appon keresztül még mindig használhatod a Mastodont.",
  "errors.unexpected_crash.copy_stacktrace": "Veremkiíratás vágólapra másolása",
  "errors.unexpected_crash.report_issue": "Probléma jelentése",
  "explore.suggested_follows": "Emberek",
  "explore.title": "Felkapott",
  "explore.trending_links": "Hírek",
  "explore.trending_statuses": "Bejegyzések",
  "explore.trending_tags": "Hashtagek",
  "featured_carousel.current": "{current, number}. <sr>bejegyzés</sr> / {max, number}",
  "featured_carousel.header": "{count, plural, one {Kiemelt bejegyzés} other {Kiemelt bejegyzések}}",
  "featured_carousel.slide": "{current, number}. bejegyzés / {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Mostanában ezekről osztottál meg dolgokat: {items}. Hozzáadod ezeket a kiemelt hashtagekhez?",
  "featured_tags.suggestions.add": "Hozzáadás",
  "featured_tags.suggestions.added": "Kezeld a kiemelt hashtageidet bármikor a <link>Profil szerkesztése > Kiemelt hashtagek</link> alatt.",
  "featured_tags.suggestions.dismiss": "Nem, köszönöm",
  "filter_modal.added.context_mismatch_explanation": "Ez a szűrőkategória nem érvényes abban a környezetben, amelyből elérted ezt a bejegyzést. Ha ebben a környezetben is szűrni szeretnéd a bejegyzést, akkor szerkesztened kell a szűrőt.",
  "filter_modal.added.context_mismatch_title": "Környezeti eltérés.",
  "filter_modal.added.expired_explanation": "Ez a szűrőkategória elévült, a használatához módosítanod kell az elévülési dátumot.",
  "filter_modal.added.expired_title": "A szűrő lejárt!",
  "filter_modal.added.review_and_configure": "A szűrőkategória felülvizsgálatához és további beállításához ugorj a {settings_link} oldalra.",
  "filter_modal.added.review_and_configure_title": "Szűrőbeállítások",
  "filter_modal.added.settings_link": "beállítások oldal",
  "filter_modal.added.short_explanation": "A következő bejegyzés hozzá lett adva a következő szűrőkategóriához: {title}.",
  "filter_modal.added.title": "Szűrő hozzáadva!",
  "filter_modal.select_filter.context_mismatch": "nem érvényes erre a környezetre",
  "filter_modal.select_filter.expired": "lejárt",
  "filter_modal.select_filter.prompt_new": "Új kategória: {name}",
  "filter_modal.select_filter.search": "Keresés vagy létrehozás",
  "filter_modal.select_filter.subtitle": "Válassz egy meglévő kategóriát, vagy hozz létre egy újat",
  "filter_modal.select_filter.title": "E bejegyzés szűrése",
  "filter_modal.title.status": "Egy bejegyzés szűrése",
  "filter_warning.matches_filter": "Megfelel a szűrőnek: „<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "{count, plural, =0 {senkitől} one {egy valószínűleg ismerős személytől} other {# valószínűleg ismerős személytől}}",
  "filtered_notifications_banner.title": "Szűrt értesítések",
  "firehose.all": "Összes",
  "firehose.local": "Ez a kiszolgáló",
  "firehose.remote": "Egyéb kiszolgálók",
  "follow_request.authorize": "Hitelesítés",
  "follow_request.reject": "Elutasítás",
  "follow_requests.unlocked_explanation": "Bár a fiókod nincs zárolva, a(z) {domain} csapata úgy gondolta, hogy talán kézzel szeretnéd ellenőrizni ezen fiókok követési kéréseit.",
  "follow_suggestions.curated_suggestion": "A stáb választása",
  "follow_suggestions.dismiss": "Ne jelenjen meg újra",
  "follow_suggestions.featured_longer": "A {domain} csapata által kézzel kiválasztott",
  "follow_suggestions.friends_of_friends_longer": "Népszerű az általad követett emberek körében",
  "follow_suggestions.hints.featured": "Ezt a profilt a(z) {domain} csapata választotta ki.",
  "follow_suggestions.hints.friends_of_friends": "Ez a profil népszerű az általad követett emberek körében.",
  "follow_suggestions.hints.most_followed": "Ez a profil a leginkább követett a(z) {domain} oldalon.",
  "follow_suggestions.hints.most_interactions": "Ez a profil mostanában sok figyelmet kap a(z) {domain} oldalon.",
  "follow_suggestions.hints.similar_to_recently_followed": "Ez a profil hasonló azokhoz a profilokhoz, melyeket nemrég kezdtél el követni.",
  "follow_suggestions.personalized_suggestion": "Személyre szabott javaslat",
  "follow_suggestions.popular_suggestion": "Népszerű javaslat",
  "follow_suggestions.popular_suggestion_longer": "Népszerű itt: {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Hasonló azokhoz a profilokhoz, melyeket nemrég követtél be",
  "follow_suggestions.view_all": "Összes megtekintése",
  "follow_suggestions.who_to_follow": "Kit érdemes követni",
  "followed_tags": "Követett hashtagek",
  "followers.hide_other_followers": "Ez a felhasználó azt választotta, hogy ne legyenek láthatóak a követői",
  "followers.title": "{name} követése",
  "following.hide_other_following": "Ez a felhasználó azt választotta, hogy ne legyenek láthatóak a követései",
  "following.title": "{name} követi",
  "footer.about": "Névjegy",
  "footer.about_mastodon": "A Mastodonról",
  "footer.about_server": "A {domain} domainről",
  "footer.about_this_server": "Névjegy",
  "footer.directory": "Profiltár",
  "footer.get_app": "Alkalmazás beszerzése",
  "footer.keyboard_shortcuts": "Gyorsbillentyűk",
  "footer.privacy_policy": "Adatvédelmi szabályzat",
  "footer.source_code": "Forráskód megtekintése",
  "footer.status": "Állapot",
  "footer.terms_of_service": "Felhasználási feltételek",
  "form_error.blank": "A mező nem lehet üres.",
  "form_field.optional": "(nem kötelező)",
  "generic.saved": "Elmentve",
  "getting_started.heading": "Első lépések",
  "hashtag.admin_moderation": "Moderációs felület megnyitása a következőhöz: #{name}",
  "hashtag.browse": "Bejegyzések ebben: #{hashtag}",
  "hashtag.browse_from_account": "@{name} bejegyzéseinek tallózása ebben: #{hashtag}",
  "hashtag.column_header.tag_mode.all": "és {additional}",
  "hashtag.column_header.tag_mode.any": "vagy {additional}",
  "hashtag.column_header.tag_mode.none": "{additional} nélkül",
  "hashtag.column_settings.select.no_options_message": "Nincs javaslat",
  "hashtag.column_settings.select.placeholder": "Addj meg hashtageket…",
  "hashtag.column_settings.tag_mode.all": "Mindegyik",
  "hashtag.column_settings.tag_mode.any": "Bármelyik",
  "hashtag.column_settings.tag_mode.none": "Egyik sem",
  "hashtag.column_settings.tag_toggle": "További címkék felvétele ehhez az oszlophoz",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} résztvevő} other {{counter} résztvevő}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} bejegyzés} other {{counter} bejegyzés}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} bejegyzés} other {{counter} bejegyzés}} ma",
  "hashtag.feature": "Kiemelés a profilodon",
  "hashtag.follow": "Hashtag követése",
  "hashtag.mute": "#{hashtag} némítása",
  "hashtag.unfeature": "Ne legyen kiemelve a profilodon",
  "hashtag.unfollow": "Hashtag követésének megszüntetése",
  "hashtags.and_other": "…és {count, plural, other {# további}}",
  "hints.profiles.followers_may_be_missing": "A profil követői lehet, hogy hiányoznak.",
  "hints.profiles.follows_may_be_missing": "A profil követései lehet, hogy hiányoznak.",
  "hints.profiles.posts_may_be_missing": "A profil egyes bejegyzései lehet, hogy hiányoznak.",
  "hints.profiles.see_more_followers": "További követők megtekintése itt: {domain}",
  "hints.profiles.see_more_follows": "További követések megtekintése itt: {domain}",
  "hints.profiles.see_more_posts": "További bejegyzések megtekintése itt: {domain}",
  "home.column_settings.show_quotes": "Idézetek megjelenítése",
  "home.column_settings.show_reblogs": "Megtolások megjelenítése",
  "home.column_settings.show_replies": "Válaszok megjelenítése",
  "home.hide_announcements": "Közlemények elrejtése",
  "home.pending_critical_update.body": "A lehető leghamarabb frissítsd a Mastodon kiszolgálódat!",
  "home.pending_critical_update.link": "Frissítések megtekintése",
  "home.pending_critical_update.title": "Kritikus biztonsági frissítés érhető el!",
  "home.show_announcements": "Közlemények megjelenítése",
  "ignore_notifications_modal.disclaimer": "A Mastodon nem tudja értesíteni azokat a felhasználókat, akiknek figyelmen kívül hagytad az értesítéseit. Az értesítések figyelmen kívül hagyása nem állítja meg az üzenetek elküldését.",
  "ignore_notifications_modal.filter_instead": "Inkább szűrés",
  "ignore_notifications_modal.filter_to_act_users": "Továbbra is el tudod fogadni, el tudod utasítani vagy tudod jelenteni a felhasználókat",
  "ignore_notifications_modal.filter_to_avoid_confusion": "A szűrés segít elkerülni a lehetséges félreértéseket",
  "ignore_notifications_modal.filter_to_review_separately": "A szűrt értesítések külön tekinthetők át",
  "ignore_notifications_modal.ignore": "Értesítések figyelmen kívül hagyása",
  "ignore_notifications_modal.limited_accounts_title": "Moderált fiókok értesítéseinek figyelmen kívül hagyása?",
  "ignore_notifications_modal.new_accounts_title": "Új fiókok értesítéseinek figyelmen kívül hagyása?",
  "ignore_notifications_modal.not_followers_title": "Nem követőktől érkező értesítések figyelmen kívül hagyása?",
  "ignore_notifications_modal.not_following_title": "Nem követettektől érkező értesítések figyelmen kívül hagyása?",
  "ignore_notifications_modal.private_mentions_title": "Figyelmen kívül hagyod a kéretlen privát említéseket?",
  "info_button.label": "Súgó",
  "info_button.what_is_alt_text": "<h1>Mi az alternatív szöveg?</h1> <p>Az alternatív szöveg képleírást biztosít a látássérültek, az alacsony sávszélességű kapcsolatokkal rendelkezők, illetve a bővebb kontextust keresők számára.</p> <p>Az egyértelmű, tömör és objektív alternatív szöveg megírásával mindenki számára akadálymentesebb és könnyebben érthető lesz.</p> <ul> <li>Rögzítsd a fontos elemeket.</li> <li>Foglald össze szövegesen a képeket.</li> <li>Használj szabályos mondatszerkezetet.</li> <li>Kerüld a felesleges információkat.</li> <li>Összetett vizuális ábrákon (például diagramokon vagy térképeken) összpontosíts a trendekre és a legfontosabb megállapításokra.</li> </ul>",
  "interaction_modal.action": "Hogy interakcióba lépj {name} bejegyzésével, be kell jelentkezned a fiókodba az általad használt Mastodon kiszolgálón.",
  "interaction_modal.action_follow": "Hogy kövesd {name} felhasználót, be kell jelentkezned a fiókodba az általad használt Mastodon-kiszolgálón.",
  "interaction_modal.go": "Ugrás",
  "interaction_modal.no_account_yet": "Még nincs fiókod?",
  "interaction_modal.on_another_server": "Másik kiszolgálón",
  "interaction_modal.on_this_server": "Ezen a kiszolgálón",
  "interaction_modal.title": "Jelentkezz be a folytatáshoz",
  "interaction_modal.username_prompt": "Például {example}",
  "intervals.full.days": "{number, plural, one {# nap} other {# nap}}",
  "intervals.full.hours": "{number, plural, one {# óra} other {# óra}}",
  "intervals.full.minutes": "{number, plural, one {# perc} other {# perc}}",
  "keyboard_shortcuts.back": "Navigálás vissza",
  "keyboard_shortcuts.blocked": "Letiltott felhasználók listájának megnyitása",
  "keyboard_shortcuts.boost": "Bejegyzés megtolása",
  "keyboard_shortcuts.column": "Fókuszálás egy oszlopra",
  "keyboard_shortcuts.compose": "Szerkesztési terület fókuszálása",
  "keyboard_shortcuts.description": "Leírás",
  "keyboard_shortcuts.direct": "Személyes említések oszlop megnyitása",
  "keyboard_shortcuts.down": "Mozgás lefelé a listában",
  "keyboard_shortcuts.enter": "Bejegyzés megnyitása",
  "keyboard_shortcuts.explore": "Felkapottak idővonalának megnyitása",
  "keyboard_shortcuts.favourite": "Bejegyzés kedvencnek jelölése",
  "keyboard_shortcuts.favourites": "Kedvencek lista megnyitása",
  "keyboard_shortcuts.federated": "Föderációs idővonal megnyitása",
  "keyboard_shortcuts.heading": "Gyorsbillentyűk",
  "keyboard_shortcuts.home": "Saját idővonal megnyitása",
  "keyboard_shortcuts.hotkey": "Gyorsbillentyű",
  "keyboard_shortcuts.legend": "Jelmagyarázat megjelenítése",
  "keyboard_shortcuts.load_more": "Fókuszálás a „Több betöltése” gombra",
  "keyboard_shortcuts.local": "Helyi idővonal megnyitása",
  "keyboard_shortcuts.mention": "Szerző megemlítése",
  "keyboard_shortcuts.muted": "Némított felhasználók listájának megnyitása",
  "keyboard_shortcuts.my_profile": "Saját profil megnyitása",
  "keyboard_shortcuts.notifications": "Értesítések oszlop megnyitása",
  "keyboard_shortcuts.open_media": "Média megnyitása",
  "keyboard_shortcuts.pinned": "Kitűzött bejegyzések listájának megnyitása",
  "keyboard_shortcuts.profile": "Szerző profiljának megnyitása",
  "keyboard_shortcuts.quote": "Bejegyzés idézése",
  "keyboard_shortcuts.reply": "Válasz bejegyzésre",
  "keyboard_shortcuts.requests": "Követési kérések listájának megnyitása",
  "keyboard_shortcuts.search": "Fókuszálás a keresősávra",
  "keyboard_shortcuts.spoilers": "Tartalmi figyelmeztetés mező megjelenítése/elrejtése",
  "keyboard_shortcuts.start": "„Első lépések” oszlop megnyitása",
  "keyboard_shortcuts.toggle_hidden": "Tartalmi figyelmeztetéssel ellátott szöveg megjelenítése/elrejtése",
  "keyboard_shortcuts.toggle_sensitivity": "Média megjelenítése/elrejtése",
  "keyboard_shortcuts.toot": "Új bejegyzés írása",
  "keyboard_shortcuts.top": "Ugrás a lista elejére",
  "keyboard_shortcuts.translate": "Bejegyzés lefordítása",
  "keyboard_shortcuts.unfocus": "Szerkesztés/keresés fókuszból való kivétele",
  "keyboard_shortcuts.up": "Mozgás felfelé a listában",
  "learn_more_link.got_it": "Rendben",
  "learn_more_link.learn_more": "További tudnivalók",
  "lightbox.close": "Bezárás",
  "lightbox.next": "Következő",
  "lightbox.previous": "Előző",
  "lightbox.zoom_in": "Nagyítás a tényleges méretre",
  "lightbox.zoom_out": "Méretre igazítás",
  "limited_account_hint.action": "Profil megjelenítése mindenképpen",
  "limited_account_hint.title": "Ezt a profilt {domain} moderátorai elrejtették.",
  "link_preview.author": "{name} szerint",
  "link_preview.more_from_author": "Több tőle: {name}",
  "link_preview.shares": "{count, plural, one {{counter} bejegyzés} other {{counter} bejegyzés}}",
  "lists.add_member": "Hozzáadás",
  "lists.add_to_list": "Hozzáadás a listához",
  "lists.add_to_lists": "{name} hozzáadása a listához",
  "lists.create": "Létrehozás",
  "lists.create_a_list_to_organize": "Új lista létrehozása a kezdőlapod szervezéséhez",
  "lists.create_list": "Lista létrehozása",
  "lists.delete": "Lista törlése",
  "lists.done": "Kész",
  "lists.edit": "Lista szerkesztése",
  "lists.exclusive": "Tagok elrejtése a kezdőlapon",
  "lists.exclusive_hint": "Ha valaki szerepel ezen a listán, el lesz rejtve a kezdőlapod hírfolyamán, hogy ne lásd kétszer a bejegyzéseit.",
  "lists.find_users_to_add": "Hozzáadandó felhasználók keresése",
  "lists.list_members_count": "{count, plural, one {# tag} other {# tag}}",
  "lists.list_name": "Lista neve",
  "lists.new_list_name": "Új lista neve",
  "lists.no_lists_yet": "Nincsenek még listák.",
  "lists.no_members_yet": "Nincsenek még tagok.",
  "lists.no_results_found": "Nincs találat.",
  "lists.remove_member": "Eltávolítás",
  "lists.replies_policy.followed": "Bármely követett felhasználó",
  "lists.replies_policy.list": "A lista tagjai",
  "lists.replies_policy.none": "Senki",
  "lists.save": "Mentés",
  "lists.search": "Keresés",
  "lists.show_replies_to": "Listatagok válaszainak hozzávétele",
  "load_pending": "{count, plural, one {# új elem} other {# új elem}}",
  "loading_indicator.label": "Betöltés…",
  "media_gallery.hide": "Elrejtés",
  "moved_to_account_banner.text": "A(z) {disabledAccount} fiókod jelenleg le van tiltva, mert átköltöztél ide: {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Elrejtés az értesítések közül",
  "mute_modal.hide_options": "Beállítások elrejtése",
  "mute_modal.indefinite": "Amíg nem oldom fel a némítást",
  "mute_modal.show_options": "Beállítások megjelenítése",
  "mute_modal.they_can_mention_and_follow": "Megemlíthet vagy követhet téged, de te nem fogod ezeket látni.",
  "mute_modal.they_wont_know": "Nem fogja tudni, hogy lenémítottad.",
  "mute_modal.title": "Elnémítsuk a felhasználót?",
  "mute_modal.you_wont_see_mentions": "Nem látsz majd őt említő bejegyzéseket.",
  "mute_modal.you_wont_see_posts": "Továbbra is látni fogja a bejegyzéseidet, de te nem fogod látni az övéit.",
  "navigation_bar.about": "Névjegy",
  "navigation_bar.account_settings": "Jelszó és biztonság",
  "navigation_bar.administration": "Adminisztráció",
  "navigation_bar.advanced_interface": "Megnyitás a speciális webes felületben",
  "navigation_bar.automated_deletion": "Bejegyzések automatikus törlése",
  "navigation_bar.blocks": "Letiltott felhasználók",
  "navigation_bar.bookmarks": "Könyvjelzők",
  "navigation_bar.collections": "Gyűjtemények",
  "navigation_bar.direct": "Személyes említések",
  "navigation_bar.domain_blocks": "Letiltott domainek",
  "navigation_bar.favourites": "Kedvencek",
  "navigation_bar.filters": "Némított szavak",
  "navigation_bar.follow_requests": "Követési kérések",
  "navigation_bar.followed_tags": "Követett hashtagek",
  "navigation_bar.follows_and_followers": "Követések és követők",
  "navigation_bar.import_export": "Importálás és exportálás",
  "navigation_bar.lists": "Listák",
  "navigation_bar.live_feed_local": "Élő hírfolyam (helyi)",
  "navigation_bar.live_feed_public": "Élő hírfolyam (nyilvános)",
  "navigation_bar.logout": "Kijelentkezés",
  "navigation_bar.moderation": "Moderáció",
  "navigation_bar.more": "Továbbiak",
  "navigation_bar.mutes": "Némított felhasználók",
  "navigation_bar.opened_in_classic_interface": "A bejegyzések, fiókok és más speciális oldalak alapértelmezés szerint a klasszikus webes felületen nyílnak meg.",
  "navigation_bar.preferences": "Beállítások",
  "navigation_bar.privacy_and_reach": "Adatvédelem és elérés",
  "navigation_bar.search": "Keresés",
  "navigation_bar.search_trends": "Keresés / felkapott",
  "navigation_panel.collapse_followed_tags": "Követett hashtagek menü összecsukása",
  "navigation_panel.collapse_lists": "Listamenü összecsukása",
  "navigation_panel.expand_followed_tags": "Követett hashtagek menü kibontása",
  "navigation_panel.expand_lists": "Listamenü kibontása",
  "not_signed_in_indicator.not_signed_in": "Az erőforrás eléréséhez be kell jelentkezned.",
  "notification.added_to_collection": "{name} hozzáadott egy gyűjteményhez",
  "notification.admin.report": "{name} jelentette: {target}",
  "notification.admin.report_account": "{name} jelentett {count, plural, one {egy bejegyzést} other {# bejegyzést}} itt: {target}, ezért: {category}",
  "notification.admin.report_account_other": "{name} jelentett {count, plural, one {egy bejegyzést} other {# bejegyzést}} itt: {target}",
  "notification.admin.report_statuses": "{name} jelentette: {target}, ezért: {category}",
  "notification.admin.report_statuses_other": "{name} jelentette: {target}",
  "notification.admin.sign_up": "{name} regisztrált",
  "notification.admin.sign_up.name_and_others": "{name} és {count, plural, one {# másik} other {# másik}} regisztrált",
  "notification.annual_report.message": "Vár a {year}. év #Wrapstodon jelentése! Fedd fel az éved jelentős eseményeit és emlékezetes pillanatait a Mastodonon!",
  "notification.annual_report.view": "#Wrapstodon megtekintése",
  "notification.collection_update": "{name} szerkesztett egy gyűjteményt, amelyben szerepelsz",
  "notification.favourite": "{name} kedvencnek jelölte a bejegyzésedet",
  "notification.favourite.name_and_others_with_link": "{name} és <a>{count, plural, one {# másik} other {# másik}}</a> kedvencnek jelölte a bejegyzésedet",
  "notification.favourite_pm": "{name} kedvelte a privát említésedet",
  "notification.favourite_pm.name_and_others_with_link": "{name} és <a>{count, plural, one {# másik} other {# másik}}</a> kedvencnek jelölte a privát említésedet",
  "notification.follow": "{name} követ téged",
  "notification.follow.name_and_others": "{name} és <a>{count, plural, one {# másik} other {# másik}}</a> követni kezdett",
  "notification.follow_request": "{name} követni szeretne téged",
  "notification.follow_request.name_and_others": "{name} és {count, plural, one {# másik} other {# másik}} kérte, hogy követhessen",
  "notification.label.mention": "Említés",
  "notification.label.private_mention": "Privát említés",
  "notification.label.private_reply": "Privát válasz",
  "notification.label.quote": "{name} idézte a bejegyzésedet",
  "notification.label.reply": "Válasz",
  "notification.mention": "Említés",
  "notification.mentioned_you": "{name} megemlített",
  "notification.moderation-warning.learn_more": "További információ",
  "notification.moderation_warning": "Moderációs figyelmeztetést kaptál",
  "notification.moderation_warning.action_delete_statuses": "Néhány bejegyzésedet eltávolították.",
  "notification.moderation_warning.action_disable": "A fiókod le van tiltva.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Néhány bejegyzésedet kényesnek jelölték.",
  "notification.moderation_warning.action_none": "A fiókod moderációs figyelmeztetést kapott.",
  "notification.moderation_warning.action_sensitive": "A bejegyzéseid mostantól érzékenynek lesznek jelölve.",
  "notification.moderation_warning.action_silence": "A fiókod korlátozásra került.",
  "notification.moderation_warning.action_suspend": "A fiókod felfüggesztésre került.",
  "notification.own_poll": "A szavazásod véget ért",
  "notification.poll": "Véget ért egy szavazás, melyben részt vettél",
  "notification.quoted_update": "{name} szerkesztett egy bejegyzést, melyet idéztél",
  "notification.reblog": "{name} megtolta a bejegyzésedet",
  "notification.reblog.name_and_others_with_link": "{name} és <a>{count, plural, one {# másik} other {# másik}}</a> megtolta a bejegyzésedet",
  "notification.relationships_severance_event": "Elvesztek a kapcsolatok vele: {name}",
  "notification.relationships_severance_event.account_suspension": "Egy admin a(z) {from} kiszolgálóról felfüggesztette {target} fiókját, ami azt jelenti, hogy mostantól nem fogsz róla értesítést kapni, és nem fogsz tudni vele kapcsolatba lépni.",
  "notification.relationships_severance_event.domain_block": "Egy admin a(z) {from} kiszolgálón letiltotta {target} domaint, beleértve {followersCount} követőt és {followingCount, plural, one {#} other {#}} követett fiókot.",
  "notification.relationships_severance_event.learn_more": "További információk",
  "notification.relationships_severance_event.user_domain_block": "Letiltottad a(z) {target} domaint, ezzel eltávolítva {followersCount} követőt és {followingCount, plural, one {#} other {#}} követett fiókot.",
  "notification.status": "{name} bejegyzést tett közzé",
  "notification.update": "{name} szerkesztett egy bejegyzést",
  "notification_requests.accept": "Elfogadás",
  "notification_requests.accept_multiple": "{count, plural, one {# kérés elfogadása…} other {# kérés elfogadása…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Kérés elfogadása} other {Kérések elfogadása}}",
  "notification_requests.confirm_accept_multiple.message": "Elfogadni készülsz {count, plural, one {egy értesítési kérést} other {# értesítési kérést}}. Biztosan folytatod?",
  "notification_requests.confirm_accept_multiple.title": "Értesítési kérések elfogadása?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Kérés elvetése} other {Kérések elvetése}}",
  "notification_requests.confirm_dismiss_multiple.message": "{count, plural, one {Egy értesítési kérés} other {# értesítési kérés}} elvetésére készülsz. Többé nem fogsz {count, plural, one {hozzáférni} other {hozzájuk férni}}. Biztosan folytatod?",
  "notification_requests.confirm_dismiss_multiple.title": "Értesítési kérések elvetése?",
  "notification_requests.dismiss": "Elvetés",
  "notification_requests.dismiss_multiple": "{count, plural, one {# kérés elvetése…} other {# kérés elvetése…}}",
  "notification_requests.edit_selection": "Szerkesztés",
  "notification_requests.exit_selection": "Kész",
  "notification_requests.explainer_for_limited_account": "Az ettől a fióktól származó értesítéseket kiszűrték, mert a fiókot egy moderátor korlátozta.",
  "notification_requests.explainer_for_limited_remote_account": "Az ettől a fióktól származó értesítéseket kiszűrték, mert a fiókot vagy annak kiszolgálóját egy moderátor korlátozta.",
  "notification_requests.maximize": "Maximalizálás",
  "notification_requests.minimize_banner": "Szűrt értesítések sávjának minimalizálása",
  "notification_requests.notifications_from": "{name} értesítései",
  "notification_requests.title": "Szűrt értesítések",
  "notification_requests.view": "Értesítések megtekintése",
  "notifications.clear": "Értesítések törlése",
  "notifications.clear_confirmation": "Biztos, hogy véglegesen törölni akarod az összes értesítésed?",
  "notifications.clear_title": "Törlöd az értesítéseket?",
  "notifications.column_settings.admin.report": "Új jelentések:",
  "notifications.column_settings.admin.sign_up": "Új regisztrálók:",
  "notifications.column_settings.alert": "Asztali értesítések",
  "notifications.column_settings.favourite": "Kedvencek:",
  "notifications.column_settings.filter_bar.advanced": "Minden kategória megjelenítése",
  "notifications.column_settings.filter_bar.category": "Gyorsszűrő sáv",
  "notifications.column_settings.follow": "Új követők:",
  "notifications.column_settings.follow_request": "Új követési kérések:",
  "notifications.column_settings.group": "Csoportosítás",
  "notifications.column_settings.mention": "Megemlítések:",
  "notifications.column_settings.poll": "Szavazási eredmények:",
  "notifications.column_settings.push": "Leküldéses értesítések",
  "notifications.column_settings.quote": "Idézetek:",
  "notifications.column_settings.reblog": "Megtolások:",
  "notifications.column_settings.show": "Megjelenítés az oszlopban",
  "notifications.column_settings.sound": "Hang lejátszása",
  "notifications.column_settings.status": "Új bejegyzések:",
  "notifications.column_settings.unread_notifications.category": "Olvasatlan értesítések",
  "notifications.column_settings.unread_notifications.highlight": "Olvasatlan értesítések kiemelése",
  "notifications.column_settings.update": "Szerkesztések:",
  "notifications.filter.all": "Összes",
  "notifications.filter.boosts": "Megtolások",
  "notifications.filter.favourites": "Kedvencek",
  "notifications.filter.follows": "Követések",
  "notifications.filter.mentions": "Megemlítések",
  "notifications.filter.polls": "Szavazások eredményei",
  "notifications.filter.statuses": "Frissítések azoktól, akiket követsz",
  "notifications.grant_permission": "Engedély megadása.",
  "notifications.group": "{count} értesítés",
  "notifications.mark_as_read": "Összes értesítés megjelölése olvasottként",
  "notifications.permission_denied": "Az asztali értesítések nem érhetők el a korábban elutasított böngészőengedély-kérelem miatt",
  "notifications.permission_denied_alert": "Az asztali értesítések nem engedélyezhetők a korábban elutasított böngésző engedély miatt",
  "notifications.permission_required": "Az asztali értesítések nem érhetőek el, mivel a szükséges engedély nem lett megadva.",
  "notifications.policy.accept": "Elfogadás",
  "notifications.policy.accept_hint": "Megjelenítés az értesítések között",
  "notifications.policy.drop": "Figyelmen kívül hagyás",
  "notifications.policy.drop_hint": "Küldés a semmibe, többé ne jelenjen meg",
  "notifications.policy.filter": "Szűrő",
  "notifications.policy.filter_hint": "Küldés a szűrt értesítések közé",
  "notifications.policy.filter_limited_accounts_hint": "A szerver moderátorai által korlátozott",
  "notifications.policy.filter_limited_accounts_title": "Moderált fiókok",
  "notifications.policy.filter_new_accounts.hint": "Az elmúlt {days, plural, one {napban} other {# napban}} létrehozva",
  "notifications.policy.filter_new_accounts_title": "Új fiókok",
  "notifications.policy.filter_not_followers_hint": "Beleértve azokat, akik kevesebb mint {days, plural, one {egy napja} other {# napja}} követnek",
  "notifications.policy.filter_not_followers_title": "Olyan emberek, akik nem követnek",
  "notifications.policy.filter_not_following_hint": "Amíg kézileg jóvá nem hagyod őket",
  "notifications.policy.filter_not_following_title": "Nem követett emberek",
  "notifications.policy.filter_private_mentions_hint": "Kiszűrve, hacsak nem a saját említésedre válaszol, vagy ha nem követed a feladót",
  "notifications.policy.filter_private_mentions_title": "Kéretlen személyes említések",
  "notifications.policy.title": "Értesítések kezelése…",
  "notifications_permission_banner.enable": "Asztali értesítések engedélyezése",
  "notifications_permission_banner.how_to_control": "Ahhoz, hogy értesítéseket kapj akkor, amikor a Mastodon nincs megnyitva, engedélyezd az asztali értesítéseket. Pontosan be tudod állítani, hogy milyen interakciókról értesülj a fenti {icon} gombon keresztül, ha egyszer már engedélyezted őket.",
  "notifications_permission_banner.title": "Soha ne mulassz el semmit",
  "onboarding.follows.back": "Vissza",
  "onboarding.follows.empty": "Sajnos jelenleg nem jeleníthető meg eredmény. Kipróbálhatod a keresést vagy böngészheted a felfedező oldalon a követni kívánt személyeket, vagy próbáld meg később.",
  "onboarding.follows.next": "Következik: A profil beállítása",
  "onboarding.follows.search": "Keresés",
  "onboarding.follows.title": "A kezdéshez kezdj el embereket követni",
  "onboarding.profile.discoverable": "Saját profil beállítása felfedezhetőként",
  "onboarding.profile.discoverable_hint": "A Mastodonon a felfedezhetőség választása esetén a saját bejegyzéseid megjelenhetnek a keresési eredmények és a felkapott tartalmak között, valamint a profilod a hozzád hasonló érdeklődési körrel rendelkező embereknél is ajánlásra kerülhet.",
  "onboarding.profile.display_name": "Megjelenített név",
  "onboarding.profile.display_name_hint": "Teljes neved vagy vicces neved…",
  "onboarding.profile.finish": "Befejezés",
  "onboarding.profile.note": "Bemutatkozás",
  "onboarding.profile.note_hint": "Megemlíthetsz @másokat vagy #hashtag-eket…",
  "onboarding.profile.title": "Profilbeállítás",
  "onboarding.profile.upload_avatar": "Profilkép feltöltése",
  "onboarding.profile.upload_header": "Profil fejléc feltöltése",
  "password_confirmation.exceeds_maxlength": "A jelszó megerősítése hosszabb a legnagyobb megengedett jelszóhossznál",
  "password_confirmation.mismatching": "A jelszómegerősítés nem egyezik",
  "picture_in_picture.restore": "Visszahelyezés",
  "poll.closed": "Lezárva",
  "poll.refresh": "Frissítés",
  "poll.reveal": "Eredmények megtekintése",
  "poll.total_people": "{count, plural, one {# személy} other {# személy}}",
  "poll.total_votes": "{count, plural, one {# szavazat} other {# szavazat}}",
  "poll.vote": "Szavazás",
  "poll.voted": "Erre a válaszra szavaztál",
  "poll.votes": "{votes, plural, one {# szavazat} other {# szavazat}}",
  "poll_button.add_poll": "Új szavazás",
  "poll_button.remove_poll": "Szavazás eltávolítása",
  "privacy.change": "Bejegyzés láthatóságának módosítása",
  "privacy.direct.long": "Mindenki, akit a bejegyzés említ",
  "privacy.direct.short": "Privát említés",
  "privacy.private.long": "Csak a követőid",
  "privacy.private.short": "Követők",
  "privacy.public.long": "Bárki a Mastodonon és azon kívül",
  "privacy.public.short": "Nyilvános",
  "privacy.quote.anyone": "{visibility}, idézés engedélyezve",
  "privacy.quote.disabled": "{visibility}, idézés letiltva",
  "privacy.quote.limited": "{visibility}, idézés korlátozva",
  "privacy.unlisted.additional": "Ez pontosan úgy viselkedik, mint a nyilvános, kivéve, hogy a bejegyzés nem jelenik meg élő hírfolyamokban, hashtagekben, felfedezésben vagy a Mastodonos keresésben, még akkor sem, ha ezt az egész fiókra engedélyezted.",
  "privacy.unlisted.long": "Elrejtve a Mastodon keresési találataiban, a felkapottak között és a nyilvános idővonalakon",
  "privacy.unlisted.short": "Csendes nyilvános",
  "privacy_policy.last_updated": "Utoljára frissítve: {date}",
  "privacy_policy.title": "Adatvédelmi szabályzat",
  "quote_error.edit": "Idézés nem adható hozzá bejegyzés szerkesztésekor.",
  "quote_error.poll": "Az idézés szavazások esetén nincs engedélyezve.",
  "quote_error.private_mentions": "Az idézés közvetlen említések esetén nem engedélyezett.",
  "quote_error.quote": "Egyszerre csak egy idézet van engedélyezve.",
  "quote_error.unauthorized": "Nem idézheted ezt a bejegyzést.",
  "quote_error.upload": "Az idézés médiamellékletek esetén nem engedélyezett.",
  "recommended": "Ajánlott",
  "refresh": "Frissítés",
  "regeneration_indicator.please_stand_by": "Kis türelmet.",
  "regeneration_indicator.preparing_your_home_feed": "Kezdőlapi hírfolyam előkészítése…",
  "relative_time.days": "{number}n",
  "relative_time.full.days": "{number, plural, one {# napja} other {# napja}}",
  "relative_time.full.hours": "{number, plural, one {# órája} other {# órája}}",
  "relative_time.full.just_now": "épp most",
  "relative_time.full.minutes": "{number, plural, one {# perce} other {# perce}}",
  "relative_time.full.seconds": "{number, plural, one {# másodperce} other {# másodperce}}",
  "relative_time.hours": "{number}ó",
  "relative_time.just_now": "most",
  "relative_time.minutes": "{number}p",
  "relative_time.seconds": "{number}mp",
  "relative_time.today": "ma",
  "remove_quote_hint.button_label": "Rendben",
  "remove_quote_hint.message": "Ezt a {icon} beállítások menüben lehet megtenni.",
  "remove_quote_hint.title": "Eltávolítod az idézett bejegyzésedet?",
  "reply_indicator.attachments": "{count, plural, one {# melléklet} other {# melléklet}}",
  "reply_indicator.cancel": "Mégsem",
  "reply_indicator.poll": "Szavazás",
  "report.block": "Letiltás",
  "report.block_explanation": "Nem fogod látni a bejegyzéseit. Nem fogja tudni megnézni a bejegyzéseidet és nem fog tudni követni sem. Azt is meg fogja tudni mondani, hogy letiltottad.",
  "report.categories.legal": "Jogi információk",
  "report.categories.other": "Egyéb",
  "report.categories.spam": "Kéretlen üzenet",
  "report.categories.violation": "A tartalom a kiszolgáló egy vagy több szabályát sérti",
  "report.category.subtitle": "Válaszd ki a legjobb találatot",
  "report.category.title": "Mondd el, hogy mi van ezzel a {type}",
  "report.category.title_account": "profillal",
  "report.category.title_status": "bejegyzéssel",
  "report.close": "Kész",
  "report.collection_comment": "Miért jelented ezt a gyűjteményt?",
  "report.comment.title": "Van valami, amiről tudnunk kellene?",
  "report.forward": "Továbbítás: {target}",
  "report.forward_hint": "Ez a fiók egy másik kiszolgálóról van. Oda is elküldésre kerüljön a jelentés egy anonimizált másolata?",
  "report.mute": "Némítás",
  "report.mute_explanation": "Nem fogod látni a bejegyzéseit. Továbbra is fog tudni követni, és látni fogja a bejegyzéseidet, és nem fogja tudni, hogy némítottad.",
  "report.next": "Következő",
  "report.placeholder": "További megjegyzések",
  "report.reasons.dislike": "Nem tetszik",
  "report.reasons.dislike_description": "Ezt nem szeretném látni",
  "report.reasons.legal": "Ez illegális",
  "report.reasons.legal_description": "Azt gondolod, hogy sérti a te vagy a kiszolgáló országának törvényeit",
  "report.reasons.other": "Valami más",
  "report.reasons.other_description": "Az eset nem illik egyik kategóriába sem",
  "report.reasons.spam": "Ez kéretlen tartalom",
  "report.reasons.spam_description": "Rosszindulatú hivatkozások, hamis interakció vagy ismétlődő válaszok",
  "report.reasons.violation": "Sérti a kiszolgáló szabályait",
  "report.reasons.violation_description": "Tudod, hogy mely konkrét szabályokat sért meg",
  "report.rules.subtitle": "Válaszd ki az összes megfelelőt",
  "report.rules.title": "Mely szabályok lettek megsértve?",
  "report.statuses.subtitle": "Válaszd ki az összes megfelelőt",
  "report.statuses.title": "Vannak olyan bejegyzések, amelyek alátámasztják ezt a jelentést?",
  "report.submission_error": "A jelentés beküldése nem sikerült",
  "report.submission_error_details": "Ellenőrizd a hálózati kapcsolatot és próbáld meg újra.",
  "report.submit": "Küldés",
  "report.target": "{target} jelentése",
  "report.thanks.take_action": "Itt vannak a beállítások, melyek szabályozzák, hogy mit látsz a Mastodonon:",
  "report.thanks.take_action_actionable": "Míg átnézzük, a következőket teheted @{name} ellen:",
  "report.thanks.title": "Nem akarod ezt látni?",
  "report.thanks.title_actionable": "Köszönjük, hogy jelentetted, megnézzük.",
  "report.unfollow": "@{name} követésének leállítása",
  "report.unfollow_explanation": "Követed ezt a fiókot. Hogy ne lásd a bejegyzéseit a kezdőlapi hírfolyamban, szüntesd meg a követését.",
  "report_notification.attached_statuses": "{count} bejegyzés mellékelve",
  "report_notification.categories.legal": "Jogi",
  "report_notification.categories.legal_sentence": "illegális tartalom",
  "report_notification.categories.other": "Egyéb",
  "report_notification.categories.other_sentence": "egyéb",
  "report_notification.categories.spam": "Kéretlen üzenet",
  "report_notification.categories.spam_sentence": "kéretlen üzenet",
  "report_notification.categories.violation": "Szabálysértés",
  "report_notification.categories.violation_sentence": "szabálysértés",
  "report_notification.open": "Bejelentés megnyitása",
  "search.clear": "Keresés törlése",
  "search.no_recent_searches": "Nincsenek keresési előzmények",
  "search.placeholder": "Keresés",
  "search.quick_action.account_search": "Profilok a következő keresésre: {x}",
  "search.quick_action.go_to_account": "Ugrás a következő profilhoz: {x}",
  "search.quick_action.go_to_hashtag": "Ugrás a következő hashtaghez: {x}",
  "search.quick_action.open_url": "Webcím megnyitása a Mastodonon",
  "search.quick_action.status_search": "Bejegyzések a következő keresésre: {x}",
  "search.search_or_paste": "Keresés vagy URL beillesztése",
  "search_popout.full_text_search_disabled_message": "Nem érhető el ezen: {domain}.",
  "search_popout.full_text_search_logged_out_message": "Csak bejelentkezve érhető el.",
  "search_popout.language_code": "ISO nyelvkód",
  "search_popout.options": "Keresési beállítások",
  "search_popout.quick_actions": "Gyors műveletek",
  "search_popout.recent": "Legutóbbi keresések",
  "search_popout.specific_date": "adott dátum",
  "search_popout.user": "felhasználó",
  "search_results.accounts": "Profilok",
  "search_results.all": "Összes",
  "search_results.hashtags": "Hashtagek",
  "search_results.no_results": "Nincs találat.",
  "search_results.no_search_yet": "Próbálj meg bejegyzések, profilok vagy címkék után keresni.",
  "search_results.see_all": "Összes megtekintése",
  "search_results.statuses": "Bejegyzések",
  "search_results.title": "Keresés erre: „{q}”",
  "server_banner.about_active_users": "Az elmúlt 30 napban ezt a kiszolgálót használók száma (Havi aktív felhasználók)",
  "server_banner.active_users": "aktív felhasználó",
  "server_banner.administered_by": "Adminisztrátor:",
  "server_banner.is_one_of_many": "{domain} egy a jelentős, független Mastodon kiszolgálók közül, melyet a fediverzumban való részvételre használhatsz.",
  "server_banner.more_about_this_server": "Több információ a kiszolgálóról",
  "server_banner.server_stats": "Kiszolgálóstatisztika:",
  "sign_in_banner.create_account": "Fiók létrehozása",
  "sign_in_banner.follow_anyone": "Kövess bárkit a fediverzumon keresztül, és láss mindent időrendi sorrendben. Algoritmusok, hirdetések, kattintásvadászat nélkül.",
  "sign_in_banner.mastodon_is": "A Mastodon a legjobb módja annak, hogy a történésekkel kapcsolatban naprakész maradj.",
  "sign_in_banner.sign_in": "Bejelentkezés",
  "sign_in_banner.sso_redirect": "Bejelentkezés vagy regisztráció",
  "skip_links.hotkey": "<span>Hotkey</span> {hotkey}",
  "skip_links.skip_to_content": "Ugrás a fő tartalomhoz",
  "skip_links.skip_to_navigation": "Ugrás a fő navigációhoz",
  "status.admin_account": "Moderációs felület megnyitása @{name} fiókhoz",
  "status.admin_domain": "Moderációs felület megnyitása {domain} esetében",
  "status.admin_status": "Bejegyzés megnyitása a moderációs felületen",
  "status.all_disabled": "A megtolások és idézések tiltva vannak",
  "status.block": "@{name} letiltása",
  "status.bookmark": "Könyvjelzőzés",
  "status.cancel_reblog_private": "Megtolás visszavonása",
  "status.cannot_quote": "Nem idézheted ezt a bejegyzést",
  "status.cannot_reblog": "Ezt a bejegyzést nem lehet megtolni",
  "status.contains_quote": "Idézést tartalmaz",
  "status.context.loading": "Több válasz betöltése",
  "status.context.loading_error": "Az új válaszok nem tölthetőek be",
  "status.context.loading_success": "Új válaszok betöltve",
  "status.context.more_replies_found": "Több válasz található",
  "status.context.retry": "Újra",
  "status.context.show": "Megjelenítés",
  "status.continued_thread": "Folytatott szál",
  "status.copy": "Link másolása bejegyzésbe",
  "status.delete": "Törlés",
  "status.delete.success": "Bejegyzés törölve",
  "status.detailed_status": "Részletes beszélgetési nézet",
  "status.direct": "@{name} személyes említése",
  "status.direct_indicator": "Személyes említés",
  "status.edit": "Szerkesztés",
  "status.edited": "Utoljára szerkesztve {date}",
  "status.edited_x_times": "{count, plural, one {{count} alkalommal} other {{count} alkalommal}} szerkesztve",
  "status.embed": "Beágyazási kód lekérése",
  "status.favourite": "Kedvenc",
  "status.favourites_count": "{count, plural, one {{counter} kedvenc} other {{counter} kedvenc}}",
  "status.filter": "E bejegyzés szűrése",
  "status.history.created": "{name} létrehozta: {date}",
  "status.history.edited": "{name} szerkesztette: {date}",
  "status.load_more": "Többet",
  "status.media.open": "Kattints a megnyitáshoz",
  "status.media.show": "Kattints a megtekintéshez",
  "status.media_hidden": "Média elrejtve",
  "status.mention": "@{name} megemlítése",
  "status.more": "Többet",
  "status.mute": "@{name} némítása",
  "status.mute_conversation": "Beszélgetés némítása",
  "status.open": "Bejegyzés kibontása",
  "status.pin": "Kitűzés a profilodra",
  "status.quote": "Idézés",
  "status.quote.cancel": "Idézés elvetése",
  "status.quote_error.blocked_account_hint.title": "Ez a bejegyzés rejtett, mert blokkoltad @{name} felhasználót.",
  "status.quote_error.blocked_domain_hint.title": "Ez a bejegyzés rejtett, mert blokkoltad a(z) {domain} domaint.",
  "status.quote_error.filtered": "A szűrőid miatt rejtett",
  "status.quote_error.limited_account_hint.action": "Megjelenítés mindenképp",
  "status.quote_error.limited_account_hint.title": "Ezt a fiókot elrejtették a(z) {domain} moderátorai.",
  "status.quote_error.muted_account_hint.title": "Ez a bejegyzés rejtett, mert némítottad @{name} felhasználót.",
  "status.quote_error.not_available": "A bejegyzés nem érhető el",
  "status.quote_error.pending_approval": "A bejegyzés függőben van",
  "status.quote_error.pending_approval_popout.body": "A Mastodonon te mondod meg, hogy valaki idézhet-e. Ez a bejegyzés addig függőben marad, amíg az eredeti szerző nem engedélyezi azt.",
  "status.quote_error.revoked": "A szerző eltávolította a bejegyzést",
  "status.quote_followers_only": "Csak a követők idézhetik ezt a bejegyzést",
  "status.quote_manual_review": "A szerző kézileg fogja jóváhagyni",
  "status.quote_noun": "Idézés",
  "status.quote_policy_change": "Módosítás, hogy kik idézhetnek",
  "status.quote_post_author": "Idézte @{name} bejegyzését",
  "status.quote_private": "A privát bejegyzések nem idézhetőek",
  "status.quotes.empty": "Senki sem idézte még ezt a bejegyzést. Ha valaki megteszi, itt fog megjelenni.",
  "status.quotes.local_other_disclaimer": "A szerző által elutasított idézések nem fognak megjelenni.",
  "status.quotes.remote_other_disclaimer": "Csak a(z) {domain} idézései jelennek meg itt garantáltan. A szerző által elutasított idézések nem fognak megjelenni.",
  "status.quotes_count": "{count, plural, one {{counter} idézet} other {{counter} idézet}}",
  "status.read_more": "Bővebben",
  "status.reblog": "Megtolás",
  "status.reblog_or_quote": "Megtolás vagy idézés",
  "status.reblog_private": "Megosztás a követőiddel",
  "status.reblogged_by": "{name} megtolta",
  "status.reblogs.empty": "Senki sem tolta még meg ezt a bejegyzést. Ha valaki megteszi, itt fog megjelenni.",
  "status.reblogs_count": "{count, plural, one {{counter} megtolás} other {{counter} megtolás}}",
  "status.redraft": "Törlés és újraírás",
  "status.remove_bookmark": "Könyvjelző eltávolítása",
  "status.remove_favourite": "Eltávolítás a kedvencek közül",
  "status.remove_quote": "Eltávolítás",
  "status.replied_in_thread": "Válaszolva a szálban",
  "status.replied_to": "Megválaszolva {name} számára",
  "status.reply": "Válasz",
  "status.replyAll": "Válasz a beszélgetésre",
  "status.report": "@{name} bejelentése",
  "status.request_quote": "Idézés kérése",
  "status.revoke_quote": "Saját bejegyzés eltávolítása @{name} bejegyzéséből",
  "status.sensitive_warning": "Kényes tartalom",
  "status.share": "Megosztás",
  "status.show_less_all": "Kevesebbet mindenhol",
  "status.show_more_all": "Többet mindenhol",
  "status.show_original": "Eredeti megjelenítése",
  "status.title.with_attachments": "{user} {attachmentCount, plural, one {mellékletet} other {{attachmentCount} mellékletet}} küldött be.",
  "status.translate": "Fordítás",
  "status.translated_from_with": "{lang} nyelvről fordítva {provider} szolgáltatással",
  "status.uncached_media_warning": "Előnézet nem érhető el",
  "status.unmute_conversation": "Beszélgetés némításának feloldása",
  "status.unpin": "Kitűzés eltávolítása a profilodról",
  "subscribed_languages.lead": "A változtatás után csak a kiválasztott nyelvű bejegyzések fognak megjelenni a kezdőlapon és az idővonalakon. Ha egy sincs kiválasztva, akkor minden nyelven megjelennek a bejegyzések.",
  "subscribed_languages.save": "Változások mentése",
  "subscribed_languages.target": "Feliratkozott nyelvek módosítása {target} esetében",
  "tabs_bar.home": "Kezdőlap",
  "tabs_bar.menu": "Menü",
  "tabs_bar.notifications": "Értesítések",
  "tabs_bar.publish": "Új bejegyzés",
  "tabs_bar.search": "Keresés",
  "tag.remove": "Eltávolítás",
  "terms_of_service.effective_as_of": "Hatálybalépés dátuma: {date}",
  "terms_of_service.title": "Felhasználási feltételek",
  "terms_of_service.upcoming_changes_on": "Érkező változások: {date}",
  "time_remaining.days": "{number, plural, one {# nap} other {# nap}} van hátra",
  "time_remaining.hours": "{number, plural, one {# óra} other {# óra}} van hátra",
  "time_remaining.minutes": "{number, plural, one {# perc} other {# perc}} van hátra",
  "time_remaining.moments": "Pillanatok vannak hátra",
  "time_remaining.seconds": "{number, plural, one {# másodperc} other {# másodperc}} van hátra",
  "trends.counter_by_accounts": "{count, plural, one {{counter} ember} other {{counter} ember}} az elmúlt {days, plural,one {napban} other {{days} napban}}",
  "trends.trending_now": "Most felkapott",
  "ui.beforeunload": "A piszkozatod el fog veszni, ha elhagyod a Mastodont.",
  "units.short.billion": "{count}Mrd",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Húzás a feltöltéshez",
  "upload_button.label": "Képek, videó vagy audiófájl hozzáadása",
  "upload_error.limit": "A fájlfeltöltési korlát elérésre került.",
  "upload_error.poll": "Szavazásnál nem lehet fájlt feltölteni.",
  "upload_error.quote": "Idézésnél nem lehet fájlt feltölteni.",
  "upload_form.drag_and_drop.instructions": "Egy médiamelléklet kiválasztásához nyomj Szóközt vagy Entert. Húzás közben használd a nyílgombokat a médiamelléklet adott irányba történő mozgatásához. A médiamelléklet új pozícióba helyezéséhez nyomd meg a Szóközt vagy az Entert, vagy a megszakításhoz nyomd meg az Esc gombot.",
  "upload_form.drag_and_drop.on_drag_cancel": "Az áthúzás megszakítva. A(z) {item} médiamelléklet el lett dobva.",
  "upload_form.drag_and_drop.on_drag_end": "A(z) {item} médiamelléklet el lett dobva.",
  "upload_form.drag_and_drop.on_drag_over": "A(z) {item} médiamelléklet át lett helyezve.",
  "upload_form.drag_and_drop.on_drag_start": "A(z) {item} médiamelléklet fel lett véve.",
  "upload_form.edit": "Szerkesztés",
  "upload_progress.label": "Feltöltés…",
  "upload_progress.processing": "Feldolgozás…",
  "username.taken": "Ez a felhasználónév foglalt. Válassz másikat.",
  "video.close": "Videó bezárása",
  "video.download": "Fájl letöltése",
  "video.exit_fullscreen": "Kilépés teljes képernyőből",
  "video.expand": "Videó nagyítása",
  "video.fullscreen": "Teljes képernyő",
  "video.hide": "Videó elrejtése",
  "video.mute": "Némítás",
  "video.pause": "Szünet",
  "video.play": "Lejátszás",
  "video.skip_backward": "Visszaugrás",
  "video.skip_forward": "Előreugrás",
  "video.unmute": "Némítás feloldása",
  "video.volume_down": "Hangerő le",
  "video.volume_up": "Hangerő fel",
  "visibility_modal.button_title": "Láthatóság beállítása",
  "visibility_modal.direct_quote_warning.text": "Ha mented a jelenlegi beállításokat, akkor a beágyazott idézet hivatkozássá lesz alakítva.",
  "visibility_modal.direct_quote_warning.title": "Idézetek nem ágyazhatóak be privát említésekbe",
  "visibility_modal.header": "Láthatóság és interakció",
  "visibility_modal.helper.direct_quoting": "A Mastodonon készült privát említéseket mások nem idézhetik.",
  "visibility_modal.helper.privacy_editing": "A láthatóság nem módosítható a bejegyzés közzététele után.",
  "visibility_modal.helper.privacy_private_self_quote": "A privát bejegyzések saját idézései nem tehetőek nyilvánossá.",
  "visibility_modal.helper.private_quoting": "A Mastodonon írt, csak követőknek szóló bejegyzéseket mások nem idézhetik.",
  "visibility_modal.helper.unlisted_quoting": "Amikor idéznek tőled, a bejegyzésük rejtve lesz a felkapott bejegyzések hírfolyamain is.",
  "visibility_modal.instructions": "Állítsd be, hogy ki léphet interakcióba a bejegyzéssel. Az összes bejegyzésre is alkalmazhatod, ha a <link>Beállítások > Bejegyzések alapértelmezései</link> lapra navigálsz.",
  "visibility_modal.privacy_label": "Láthatóság",
  "visibility_modal.quote_followers": "Csak követőknek",
  "visibility_modal.quote_label": "Ki idézhet",
  "visibility_modal.quote_nobody": "Csak én",
  "visibility_modal.quote_public": "Bárki",
  "visibility_modal.save": "Mentés"
}
